<template>

    <div class="container-fluid">

        <div id="builder" class="row justify-content-center">
            <div class="col">
                <div class="card tab-content">
                    <div class="card-header">
    
                        <div class="row d-flex">

                            <div class="col-2 col-sm-3 order-1 order-sm-0">
                              <ul class="nav nav-pills card-header-pills justify-content-start">
                                <li v-if="tabActive=='builder-tab'" class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="togglePopupelements"><i :class="{'fa':true,'fa-arrow-right':!popupelementsNavActive,'fa-arrow-left':popupelementsNavActive,}"></i></a>
                                </li>
                              </ul>
                            </div>

                            <div class="col-12 col-sm-6 order-0 order-sm-1">
                              <h4 class="pt-2 mb-0 pb-1 text-center"><span class="popup-name" @click="goToSettings">{{ popupName }}</span></h4>
                            </div>

                            <div class="col-10 col-sm-3 order-2 order-sm-2 pr-0">
                              <ul class="nav nav-pills card-header-pills justify-content-end w-100">

                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="javascript:" @click="savePopup('preview-popup')" title="Test your form"><i class="fa fa-eye"></i></a>
                                </li>
                                <li class="nav-item">
                                    <a class="btn btn-primary mr-1" href="#" @click="savePopup" title="Save"><i class="fa fa-save"></i></a>
                                </li>
                                
                              </ul>
                            </div>

                          </div>
                          
                    </div>

                    <div class="card-body p-0 popup-builder-container tab-pane active" id="popupBuilderContainer" role="tabpanel" aria-labelledby="builder-tab">

                        <div class="row">

                            <div class="col-12 col-md-3 builder-popupelements-nav" v-show="popupelementsNavActive" id="popupelementsNav">

                                  <a class="btn btn-primary btn-sm builder-popupelement-nav-close d-none" href="javascript:;" @click="closePopupelementNav()"><i class="fa fa-close"></i></a>

                                  <b-nav vertical >

                                      <b-nav-item v-for="popupelementtemplates in popupelementtemplatesnav" :key="popupelementtemplates.id"  class="popupelement-template-nav" v-if="popupelementtemplates.popupelement_templates.length">

                                          <!--<b-button :id="'accordion_'+popupelementtemplates.id+'_button'" popupelement block squared v-b-toggle="'accordion_' + popupelementtemplates.id" varient="outline-primary">{{ popupelementtemplates.name }}</b-button> -->
                                        
                                          <!-- <b-collapse :id="'accordion_'+popupelementtemplates.id" role="tabpanel" @shown="scrollPopupelementNav(popupelementtemplates.id)"> -->

                                            <draggable :group="{ name: 'popupelements', pull: 'clone', put: false }" :sort="false"  :clone="initClonePopupelement" :list="popupelementtemplates.popupelement_templates">
                                              <div v-for="popupelementtemplate in popupelementtemplates.popupelement_templates" :data-popupelementTemplateId="popupelementtemplate.id" class="popupelementtemplate">
                                                <a :id="'accordion_'+popupelementtemplates.id+'_popupelementSelectLink_'+popupelementtemplate.id" class="popupelement-select" href="javascript:;" @click="selectPopupelement" :data-popupelementTemplateId="popupelementtemplate.id">
                                                  <img class="popupelement-preview" :src="popupelementtemplate.thumbnail"/>
                                                  <!-- <div class="popupelement-name">{{ popupelementtemplate.name }} {{ popupelementtemplate.user_id }}</div> -->
                                                </a>
                                                <div v-if="popupelementtemplates.user_id" class="popupelement-nav-controls">
                                                  <i class="popupelement-control btn btn-light fa fa-trash" @click="deleteCustomPopupelement(popupelementtemplate.id)"></i>
                                                </div>
                                                <div v-if="popupelementtemplates.company_id && manageCompanyCards" class="popupelement-nav-controls">
                                                  <i class="popupelement-control btn btn-light fa fa-trash" @click="deleteCompanyPopupelement(popupelementtemplate.id)"></i>
                                                </div>
                                              </div>
                                            </draggable>

                                          <!-- </b-collapse>   -->

                                      </b-nav-item>

                                  </b-nav>

                            </div>
                            <div class="col popupbuilder-build-area sizzledeck d-flex align-items-center justify-content-center" id="popupBuildArea" >
                              <div :class="'embed-builder style_'+embedSettings.popstyle">

                                  <div v-b-modal.modal-pop-image-cropper v-if="embedSettings.popstyle=='1'" class="bgimg" :style="'background-image:url(\''+embedSettings.popimg+'\');'"></div>

                                  
                                  <div class="formarea">
                                  <draggable v-model="popupelements" group="popupelements" @start="closeSettings();updatePopupelementsFromInline();" @end="initMediumEditor();" @add="selectPopupelement" handle=".handle" :class="'draggable-area body-size-'+deckBodySize+' heading-size-'+deckHeadingSize">
                                    <div v-for="(popupelement, index) in popupelements" :key="popupelement.id" class="editable-popupelement-wrap">

                                    <div :ref="'editable_popupelement_'+index" :id="'editable_popupelement_'+index" class="editable-popupelement" v-html="popupelement.html" :data-popupelementIndex="index" @click="closeSettings()"></div> 

                                      <div class="popupelement-controls d-flex mx-4 mx-md-5">
                                        <div class="popupelement-control-wrap">
                                          <i class="popupelement-control btn btn-light fa fa-arrows handle" @mousedown="destroyMediumEditor();" @mouseup="initMediumEditor();" @click="initMediumEditor();"></i>
                                        </div>
                                        <div class="popupelement-control-wrap stacked">
                                          <i v-if="index != 0" class="popupelement-control btn btn-light fa fa-arrow-up" @click="movePopupelementUp(index)"></i>
                                          <i v-else class="popupelement-control btn btn-light fa fa-arrow-up disabled"></i>
                                          <i v-if="index < (popupelements.length -1)" class="popupelement-control btn btn-light fa fa-arrow-down" @click="movePopupelementDown(index)"></i>
                                          <i v-else class="popupelement-control btn btn-light fa fa-arrow-down disabled"></i>
                                        </div>
                                        <div v-if="popupelement.editable[0].type !== 'multiline'" class="popupelement-control-wrap">
                                          <i class="popupelement-control btn btn-light fa fa-edit" @click="openSettings(index)"></i>
                                        </div>
                                        <div class="popupelement-control-wrap stacked">
                                          <i class="popupelement-control btn btn-light fa fa-copy" @click="duplicatePopupelement(index)"></i>
                                          <i class="popupelement-control btn btn-light fa fa-trash" @click="removePopupelement(index)"></i>
                                        </div>
                                      </div>
                                    </div>
                                  </draggable>


                                  <p class="mx-2 px-4 gdpr-notice"><small class="text-muted">{{ popupGDPR }}</small></p>
                                  </div>
                                  
                                

                              </div>
                            </div>
                            <div :class="{'col-12 col-md-3 builder-popupelement-settings':true,'col-md-8':editingImage}" v-show="popupelementSettingsActive">
                                <nav class="navbar bg-light ">
                                  <a class="btn btn-primary mr-1 builder-popupelement-settings-close" href="#" @click="closeSettings()"><i class="fa fa-close"></i></a>
                                  

                                    <div class="d-flex flex-column">
                                    <template v-for="(popupelementSetting, index) in popupelementSettings">

                                        <div v-if="disableSummernote != true">

                                          <div v-if="popupelementSetting.type == 'singleline'">
                                            <h3 class="mt-4" v-text="popupelementSetting.label"></h3>
                                            <div editable class="summernoteTargetHeading" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-html="popupelementSetting.html"></div>
                                            
                                          </div>

                                          <div v-if="popupelementSetting.type == 'multiline'">
                                            <h3 class="mt-4" v-text="popupelementSetting.label"></h3>
                                            
                                            <div class="summernoteTargetText" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-html="popupelementSetting.html"></div>
                                          </div>

                                          <div v-if="popupelementSetting.type == 'plaintext'">
                                            <h3 class="mt-4" v-text="popupelementSetting.label"></h3>                                          
                                            <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.html" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </div>

                                        </div>

                                        <div v-if="popupelementSetting.type == 'image-with-cropper'">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>
                                          

                                          <upload-image :image="popupelementSetting.image" :reference="popupelementSetting.reference" @newImageSrc="onNewImageSrc" :showButton="false"></upload-image>

                                          <div class="text-center">
                                            <b-button v-b-modal.modal-medialib-image>Choose From Library</b-button>

                                            <b-modal id="modal-medialib-image" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="popupelementSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibrary"></sd-media-manager>
                                            </b-modal>

                                          </div>

                                        </div>

                                        <div v-if="popupelementSetting.type == 'image'">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>
                                          

                                          <img class="w-100 pb-3" :src="popupelementSetting.image" :reference="popupelementSetting.reference" />

                                          <div class="text-center">
                                            <b-button v-b-modal="'modal-medialib-image_'+popupelementSetting.reference">Replace Image</b-button>

                                            <b-modal :id="'modal-medialib-image_'+popupelementSetting.reference" :ref="'modal-medialib-image_'+popupelementSetting.reference" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="popupelementSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibrary"></sd-media-manager>
                                            </b-modal>

                                          </div>

                                          <div v-if="!(typeof popupelementSetting.link === 'undefined')">
                                            <label class="pr-2 pt-2">Link:</label>                                      
                                            <input class="w-100 mb-2" :ref="'link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference" type="url" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.link" @change="updatePopupelementFromSettings" @blur="updatePopupelementFromSettings" />                                          
                                            <div v-if="$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference] && $refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0]">
                                              <small v-if="!$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>
                                          </div>

                                        </div>

                                        <div v-if="popupelementSetting.type == 'avatar'">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <upload-avatar :image="popupelementSetting.image" :reference="popupelementSetting.reference" @newImageSrc="onNewImageSrc" :newimagefromlib="newImageFromLib" @editingImage="onEditingImage"></upload-avatar>

                                          <div class="text-center">
                                            <b-button v-b-modal.modal-medialib-avatar>Choose From Library</b-button>

                                            <b-modal id="modal-medialib-avatar" title="Media Library" size="xl" :hide-footer="true">
                                              <sd-media-manager prefix="/sd-media/" :reference="popupelementSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibraryForAvatar"></sd-media-manager>
                                            </b-modal>

                                          </div>


                                        </div>

                                        <div v-if="popupelementSetting.type == 'video'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <div class="input-group">
                                              <input type="text" class="form-control" :data-popupelementIndex="popupelementSetting.popupelementIndex" :data-reference="popupelementSetting.reference" :value="popupelementSetting.video" />
                                              <span class="input-group-btn">
                                                  <button type="button" class="btn btn-primary" @click="updateVideo(popupelementSetting.reference)">Update</button>
                                              </span>
                                          </div>

                                          
                                        </div>

                                        <div v-if="popupelementSetting.type == 'button'" class="w-100">

                                          <h3 class="mt-4 mb-3" v-text="popupelementSetting.label"></h3>
                                          
                                          <div v-if="popupelementSetting.hasOwnProperty('link')">
                                            <label v-if="typeof popupelementSetting.linklabel !== 'undefined'" class="pr-2 pt-2">{{ popupelementSetting.linklabel }}:</label>                                      
                                            <label v-else class="pr-2 pt-2">Link:</label>                                      
                                            <input class="w-100 mb-2" :ref="'link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference" 

                                            :type="typeof popupelementSetting.linkprepend == 'undefined' && typeof popupelementSetting.linkappend == 'undefined' ? 'url' : 'text'" 

                                            :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.link" @change="updatePopupelementFromSettings" @blur="updatePopupelementFromSettings" />                                          
                                            <div v-if="$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference] && $refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0]">
                                              <small v-if="!$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>
                                          </div>

                                          <div v-if="popupelementSetting.hasOwnProperty('text')">
                                            <label class="pr-2 pt-2">Button Text:</label>                                    
                                            <input class="w-100 mb-2" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.text" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </div>
                                          <div v-if="popupelementSetting.hasOwnProperty('background')" class="input-group mb-3">
                                            
                                            <label class="pr-2 pt-2 w-100">Button Colour:</label>
                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="popupelementSetting.background" 
                                              @input="updatePopupelementFromSettings"
                                              :colors="swatchplusdefault(swatches,popupelementSetting.reference)"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#buttonBackgroundCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="buttonBackgroundCollapse">
                                              <vue-color 
                                                :value="popupelementSetting.background" 
                                                @input="setVueBackground($event,popupelementSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                              ></vue-color>
                                            </b-collapse>
                                          </div>

                                          <div v-if="popupelementSetting.hasOwnProperty('color')" class="input-group mb-3">

                                            <label class="pr-2 pt-2 w-100">Button Text Colour:</label>
                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="popupelementSetting.color" 
                                              @input="updatePopupelementFromSettings"
                                              :colors="swatchplusdefault(swatches,popupelementSetting.reference)"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#buttonColorCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="buttonColorCollapse">
                                              <vue-color 
                                                :value="popupelementSetting.color" 
                                                @input="setVueColor($event,popupelementSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                                swatch-size="30"
                                              ></vue-color>
                                            </b-collapse>
                                                                        

                                          </div>
                                          
                                        </div>

                                        <div v-if="popupelementSetting.type == 'showhide'">
                                          
                                          <div class="form-check">
                                            <input type="checkbox" class="form-check-input" v-model="popupelementSetting.state" :id="'showhide_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                            <label class="form-check-label" :for="'showhide_'+popupelementSetting.reference" v-text="">{{ popupelementSetting.label }}</label>
                                          </div>

                                        </div>


                                        <div v-if="popupelementSetting.type == 'link'" class="w-100">

                                          <h3 class="mt-4 mb-3" v-text="popupelementSetting.label"></h3>
                                          
                                            <label v-if="typeof popupelementSetting.linklabel !== 'undefined'" class="pr-2 pt-2">{{ popupelementSetting.linklabel }}:</label>                                      
                                            <label v-else class="pr-2 pt-2">Link:</label>                                       
                                            <input class="w-100 mb-2" :ref="'link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference" type="url" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.link" @change="updatePopupelementFromSettings" @blur="updatePopupelementFromSettings" />                                          
                                            <div v-if="$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference] && $refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0]">
                                              <small v-if="!$refs['link_'+popupelementSetting.popupelementIndex+'_'+popupelementSetting.reference][0].validity.valid" class="text-danger">URL is not valid. Please make sure it begins with http:// or https://</small>
                                            </div>

                                        </div>


                                        <div v-if="popupelementSetting.type == 'background'" class="w-100 order-12">

                                          <h3 class="mt-4 mb-3" v-text="popupelementSetting.label"></h3>


                                          <div v-if="popupelementSetting.hasOwnProperty('skin')" class="input-group mb-3">

                                              <label class="pr-2 pt-2">Text Colour:</label>
                                              <b-form-select v-model="popupelementSetting.skin" @change="updatePopupelementFromSettings">
                                                <option value="light">Default (Company Text Colour)</option>
                                                <option value="dark">Inverted (Card Background Colour)</option>
                                              </b-form-select>

                                          </div>

                                          <div v-if="popupelementSetting.hasOwnProperty('color')" class="input-group mb-3">
                                            
                                            <label class="pr-2 pt-2">Card Background Colour:</label>


                                            <div class="w-100">
                                            <v-swatches 
                                              v-model="popupelementSetting.color" 
                                              @input="updatePopupelementFromSettings"
                                              :colors="swatches"
                                              backgroundColor="transparent"
                                              inline
                                              :wrapper-style="{ paddingLeft: '0px', paddingTop: '0px' }"
                                              swatch-size="30"
                                            ></v-swatches> 
                                            </div>
                                            <div class="w-100">
                                              <a v-b-toggle href="#backgroundColorCollapse" class="text-muted" @click.prevent>
                                                <span class="when-open">Hide</span><span class="when-closed">Show</span> Advanced Picker <span class="when-open"><i class="fa fa-angle-double-up" aria-hidden="true"></i></span><span class="when-closed"><i class="fa fa-angle-double-down" aria-hidden="true"></i></span>
                                              </a>
                                            </div>
                                            <b-collapse id="backgroundColorCollapse">
                                              <vue-color 
                                                :value="popupelementSetting.color ? popupelementSetting.color : deckGroundColor" 
                                                @input="setVueColor($event,popupelementSetting.reference)" 
                                                disableAlpha 
                                                :presetColors="[]"
                                                swatch-size="30"
                                              ></vue-color>
                                            </b-collapse>


                                          </div>

                                          <div  v-if="popupelementSetting.hasOwnProperty('image')" class="input-group mb-3"> 

                                              <div class="text-center">
                                                <label class="pr-2">Background Image:</label><b-button v-b-modal.modal-medialib-popupelementbackground variant="primary" title="Choose Image"><i class="fa fa-image"></i></b-button> <b-button @click="removePopupelementSettingImage(popupelementSetting.reference)" title="Clear Image"><i class="fa fa-trash"></i></b-button>

                                                <b-modal id="modal-medialib-popupelementbackground" title="Media Library" size="xl" :hide-footer="true">
                                                  <sd-media-manager prefix="/sd-media/" :reference="popupelementSetting.reference" @selectedImageFromLibrary="onSelectedImageFromLibraryForPopupelementBackground"></sd-media-manager>
                                                </b-modal>

                                              </div>

                                          </div>
                                          
                                        </div>


                                        <!-- Pop Up Elements Start -->
                                        <div v-if="popupelementSetting.type == 'input-select'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <p><label class="pr-2">Options (one per line):</label>
                                          <textarea class="w-100" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings"></textarea>
                                          </p>


                                          <p>     
                                            <div class="form-check">
                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>

                                          <p>
                                            <label class="pr-2">Unique ID:</label>
                                            <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.uid" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>


                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-text'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>

                                          <p><label class="pr-2">Unique ID:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.uid" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>


                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-textarea'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>

                                          <p><label class="pr-2">Unique ID:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.uid" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>


                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-firstname'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <!--<p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>-->


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>



                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-lastname'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <!--<p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>-->


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>



                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-companyname'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <!--<p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>-->


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>


                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-email'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <!--<p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>-->


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>


                                        </div>
                                        <div v-if="popupelementSetting.type == 'input-telephone'" class="">

                                          <h3 class="mt-4" v-text="popupelementSetting.label"></h3>

                                          <p><label class="pr-2">Label:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.placeholder" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" /></p>


                                          <!--<p><label class="pr-2">Default Value:</label>
                                          <input class="w-100" type="text" :data-reference="popupelementSetting.reference" :data-popupelementIndex="popupelementSetting.popupelementIndex" v-model="popupelementSetting.content" @change="updatePopupelementFromSettings" @keyup="updatePopupelementFromSettings" />
                                          </p>-->


                                          <p>     
                                            <div class="form-check">

                                              <input type="checkbox" class="form-check-input" v-model="popupelementSetting.required" :id="'required_'+popupelementSetting.reference" @change="updatePopupelementFromSettings">
                                              <label class="pr-2" :for="'required_'+popupelementSetting.reference" >Make field required</label> 
                                            </div>
                                          </p>


                                        </div>
                                        <!-- Pop Up Elements End -->



                                    </template>
                                    </div>
                                  
                           

                                </nav>

                            </div>

                        </div>

                    </div>

                    <div class="card-body  popup-config-container tab-pane" id="popupConfigContainer" role="tabpanel" aria-labelledby="config-tab">
                      
                      <div class="row">
                        <div class="col">

                          
                            <b-form-group
                                id="input-group-popupname"
                                label="Form Name:"
                                label-for="input-popupname"
                                description="Enter a name so you can identify the form, this is for your use and is not visible on your form."
                              >
                              <b-form-input
                                id="input-popupname"
                                v-model="popupName"
                                type="text"
                                placeholder="Enter a name"
                                required
                              ></b-form-input>
                            </b-form-group>
                          




                            <b-form-group
                                id="input-group-thankmsg"
                                label="Thank You Message:"
                                label-for="input-thankmsg"
                                description="This message will be shown on when the form has been submitted."
                              >
                              <b-form-input
                                id="input-thankmsg"
                                v-model="popupThankMsg"
                                type="text"
                                placeholder="Enter a Thank You Message"
                                required
                              ></b-form-input>
                            </b-form-group>

                            <!--
                            <b-form-group
                                id="input-group-popupcreatecontact"
                                label="Should a SizzleDeck contact be created when this Pop Up is filled in?"
                                label-for="input-popupcreatecontact"
                                description="Please note: This function will only work if an email address and/or telephone number is supplied."
                              >
                              <b-form-checkbox v-model="popupCreateContact" name="check-button" button button-variant="primary" id="input-popupcreatecontact">
                                <span v-if="popupCreateContact">
                                  Yes, this Pop Up will create SizzleDeck contacts
                                </span>
                                <span v-else>                                
                                  No, this Pop Up will not create SizzleDeck contacts
                                </span>
                              </b-form-checkbox>
                            </b-form-group>
                            -->

                            <!--
                            <b-form-group
                                id="input-group-popupoverwritecontact"
                                label="Should existing contact information be updated?"
                                label-for="input-popupoverwritecontact"
                                description="If an existing SizzleDeck contact is found, but it has different information, eg. a different first name, should the contact be update with the new details?"

                                v-if="popupCreateContact"
                              >
                              <b-form-checkbox v-model="popupOverwriteContact" name="check-button" button button-variant="primary" id="input-popupoverwritecontact">
                                <span v-if="popupOverwriteContact">
                                  Yes, existing contacts should be updated.
                                </span>
                                <span v-else>                                
                                  No, exiting contacts should not be updated.
                                </span>
                              </b-form-checkbox>
                            </b-form-group>
                            -->

                            <b-form-group
                                id="input-group-popupsenddeck"
                                label="SizzleDeck to send when form has been submitted:"
                                label-for="input-popupsenddeck"

                                v-if="popupCreateContact"
                              >

                              <b-form-select id="input-popupsenddeck" v-model="popupSendDeck" :options="templateDecks"></b-form-select>

                            </b-form-group>


                            <b-form-group
                                id="input-group-popupsenddeckfrom"
                                label="Select the user who the deck will be sent from:"
                                label-for="input-popupsenddeckfrom"
                                v-if="(popupSendDeck && popupCreateContact && (companyUsers.length > 1))"
                              >

                              <b-form-select id="input-popupsenddeckfrom" v-model="popupSendDeckFrom" :options="companyUsers"></b-form-select>

                            </b-form-group>


<!--
                            <b-form-group
                                id="input-group-popupsenddeckfrom"
                                label="Should the SizzleDeck be sent via SMS, Email or Both?"
                                label-for="input-popupsenddeckfrom"
                                v-if="(popupSendDeck && popupCreateContact)"
                              >

                              <b-form-select id="input-popupsenddeckfrom" v-model="popupSendDeckVia" :options="[{'value':'both','text':'Both'},{'value':'email','text':'Email Only'},{'value':'sms','text':'SMS Only'}]"></b-form-select>

                            </b-form-group>
-->
                            <div v-if="(popupSendDeck  && popupCreateContact)">

                              <b-form-group label="SMS Message" v-if="(popupSendDeckVia == 'sms' || popupSendDeckVia == 'both')">
                                  <b-input type="text" v-model="sms_message" @click="setSmsInputPos" @keyup="setSmsInputPos"></b-input>
                                  <p class="placeholders mt-2">Merge Tags: 
                                    <span class="placeholder" @click="insertTag">[firstname fallback=there]</span> 
                                    <span class="placeholder" @click="insertTag">[company]</span> 
                                    <span class="placeholder" @click="insertTag">[lastname]</span> 
                                  </p>
                                  <small class="text-muted">{{ 'Sending this SMS will use '+ Math.ceil(sms_message.length / 120)*parseInt(sms_credit_value) +' credit' }}<span v-if="parseInt(sms_credit_value) > 1">s</span> (subject to the length of placeholders used).</small>
                              </b-form-group>
                              
                              <b-form-group label="Email Subject" v-if="(popupSendDeckVia == 'email' || popupSendDeckVia == 'both')">
                                <b-input type="text" v-model="email_subject"></b-input>
                              </b-form-group>

                              <b-form-group label="Email Message" v-if="(popupSendDeckVia == 'email' || popupSendDeckVia == 'both')">
                                <b-form-textarea type="text" v-model="email_body"></b-form-textarea>
                              </b-form-group>

                              <b-form-group label="Button Text" v-if="(popupSendDeckVia == 'email' || popupSendDeckVia == 'both')">
                                <b-input type="text" v-model="email_button"></b-input>
                              </b-form-group>

                              <b-form-group label="Email Footer" v-if="(popupSendDeckVia == 'email' || popupSendDeckVia == 'both')">
                                <b-form-textarea type="text" v-model="email_footer"></b-form-textarea>
                              </b-form-group>

                            </div>


                        </div>
                        <div class="col">
                          


                            <b-form-group
                                id="input-group-popupNotify"
                                label="Notification List:"
                                label-for="input-popupNotify"
                                description="Multiple emails should be comma-separated. Leave blank to turn off notifications."
                              >
                              <b-form-input
                                id="input-popupNotify"
                                v-model="popupNotify"
                                type="text"
                                placeholder="Who should be emailed when a form is completed?"
                                required
                              ></b-form-input>
                            </b-form-group>


                            <b-form-group
                                id="input-group-gdpr"
                                label="GDPR Statement:"
                                label-for="input-gdpr"
                                description="This is displayed at the bottom of the form"
                              >
                              <b-form-input
                                id="input-gdpr"
                                v-model="popupGDPR"
                                type="text"
                                required
                              ></b-form-input>
                            </b-form-group>

                            <b-form-group
                                id="input-group-redirect"
                                label="Redirect after form fill:"
                                label-for="input-redirect"
                                description="Redirect user after form has been submitted. (leave blank to disable)"
                              >
                              <b-form-input
                                id="input-redirect"
                                v-model="popupRedirect"
                                type="text"
                                placeholder="Enter the full url of where the user should be redirected."
                                required
                              ></b-form-input>
                            </b-form-group>
                          

                            <b-form-group
                                id="input-group-popup-georestrict"
                                label="Should the form launch for non UK visitors?"
                              >

                              <b-form-radio v-model="geo_restrict" name="some-radios" value="GB">Only launch form for UK visitors</b-form-radio>
                              <b-form-radio v-model="geo_restrict"  name="some-radios" value="">Launch for all visitors</b-form-radio>
                              <small v-if="!geo_restrict" class="text-muted">Please Note: Some countries do not support SMS.</small>
                            </b-form-group>


                        </div>
                      </div>
                    </div>
                    <div class="card-body  popup-embed-container tab-pane" id="popupEmbedContainer" role="tabpanel" aria-labelledby="embed-tab">
                      
                      <div class="row">
                        <div class="col">
                          <b-form-group label="When should the form be shown?" label-for="embedSettingsDelay">
                            <b-form-select @change="embedSettingsChanged" id="embedSettingsDelay" v-model="embedSettings.delay" :options="[{value:500,text:'Immediately'},{value:5000,text:'After 5 seconds'},{value:10000,text:'After 10 seconds'},{value:30000,text:'After 30 seconds'},{value:'\x27scroll\x27',text:'When visitor scrolls 30%'},{value:'\x27exit\x27',text:'When the visitor shows \'exit intent\''},{value:'\x27trigger\x27',text:'When Button is Clicked'}]"></b-form-select>
                          </b-form-group>
                          <b-form-group label="If the form is closed by the user:" label-for="embedSettingsCookieClosed">
                            <b-form-select @change="embedSettingsChanged" id="embedSettingsCookieClosed" v-model="embedSettings.cookieClosed" :options="[{value:0,text:'Show next time user visits the page'},{value:1,text:'Hide form for 1 Day'},{value:7,text:'Hide form for 1 Week'},{value:30,text:'Hide form for 1 Month'}]"></b-form-select>
                          </b-form-group>
                          <b-form-group label="If the form is completed:" label-for="embedSettingsCookieCompleted">
                            <b-form-select @change="embedSettingsChanged" id="embedSettingsCookieCompleted" v-model="embedSettings.cookieCompleted" :options="[{value:0,text:'Show next time user visits the page'},{value:1,text:'Hide form for 1 Day'},{value:7,text:'Hide form for 1 Week'},{value:30,text:'Hide form for 1 Month'}]"></b-form-select>
                          </b-form-group>
                          <b-form-group label="Position of Popup:" label-for="embedSettingsPosition">
                            <b-form-select  @change="embedSettingsChanged"id="embedSettingsPosition" v-model="embedSettings.position" :options="[{value:'center-center',text:'Center Middle'},{value:'top-left',text:'Top Left'},{value:'top-center',text:'Top Middle'},{value:'top-right',text:'Top Right'},{value:'center-left',text:'Center Left'},{value:'center-right',text:'Center Right'},{value:'bottom-left',text:'Bottom Left'},{value:'bottom-center',text:'Bottom Middle'},{value:'bottom-right',text:'Bottom Right'}]"></b-form-select>
                          </b-form-group>

                          <b-form-group label="form Style:" label-for="embedSettingsPopStyle">
                            <b-form-select @change="embedSettingsChanged" id="embedSettingsPopStyle" v-model="embedSettings.popstyle" :options="[{value:0,text:'Normal'},{value:1,text:'With Image'}]"></b-form-select>
                          </b-form-group>

                          <div v-if="embedSettings.popstyle==1" class="mb-3">
                            <b-form-group label="Image to use on popup:">
                            <div class="row justify-content-center">
                              <div class="col-4 text-center"> 
                                
                                <img v-if="embedSettings.popimg" :src="embedSettings.popimg" class="w-100 mb-3" />
                                <b-button v-b-modal.modal-pop-image-cropper><span v-if="!embedSettings.popimg">Choose</span><span v-else>Replace</span> Image</b-button>

                              </div>

                            </div>
                            </b-form-group>
                          </div>

                        </div>
                        <div class="col">

                          <b-form-group label="Copy and paste this code onto the page where you want the form to be shown:" label-for="embedCode">
                            <textarea readonly class="form-control" rows="6" v-text="embedCode" id="embedCode"></textarea>                           
                            <copy-to-clipboard :text="embedCode" @copy="copyPopupCode"><b-button variant="outline-secondary mt-3"><i class="fa fa-copy"></i> Copy Code to Clipboard</b-button></copy-to-clipboard>
                          </b-form-group>

                          <div v-if="embedSettings.delay=='\x27trigger\x27'">
                            <p>To launch popup add the following css class to the 'trigger' element (button, link etc.): <input type="text" class="form-control" :value="'launch_sdpop_'+popupId"></p>
                          </div>

                          <p  v-if="!showAdvancedSettings"><a href="javascript:" @click="showAdvanced">Advanced Settings</a></p>
                          <div v-if="showAdvancedSettings">
                            

                          <b-form-group label="Inject Custom CSS into form:" label-for="extraCSS">
                            <b-form-textarea
                              id="extraCSS"
                              v-model="extraCSS"
                              placeholder="Custom CSS..."
                              rows="3"
                              max-rows="6"
                            ></b-form-textarea>
                            </b-form-group>
                          </div>


                        </div>
                      </div>
                      <div class="row">
                        <div class="col">
                          <p class="strong">Please Note: you will need to update the code block on your website to see the changes to your form.</p>
                        </div>
                      </div>

                    </div>

                    <div class="card-footer pt-0 border-top-0">
                      <ul class="nav nav-tabs tabs-below" id="myTab" role="tablist">
                        <li class="nav-item">
                          <a class="nav-link active" id="builder-tab" data-toggle="tab" href="#popupBuilderContainer" role="tab" aria-controls="builder" aria-selected="true" @click="activeTab('builder-tab')">Builder</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="config-tab" data-toggle="tab" href="#popupConfigContainer" role="tab" aria-controls="config" aria-selected="false" @click="activeTab('config-tab')">Settings</a>
                        </li>
                        <li class="nav-item">
                          <a class="nav-link" id="embed-tab" data-toggle="tab" href="#popupEmbedContainer" role="tab" aria-controls="embed" aria-selected="false" @click="activeTab('embed-tab')">Behaviour</a>
                        </li>
                      </ul>
                    </div>

                </div>
            </div>
        </div>


        
        <b-modal ref="modal-medialib-inline-image" id="modal-medialib-inline-image" title="Media Library" size="xl" :hide-footer="true">
            <sd-media-manager prefix="/sd-media/" @selectedImageFromLibrary="onSelectedImageFromLibraryForInlineImage"></sd-media-manager>
        </b-modal>
        
        <b-modal ref="modal-pop-image-cropper" id="modal-pop-image-cropper" title="Choose Image" size="xl" :hide-footer="true">
            <upload-image :image="embedSettings.popimg" :aspect="378 / 480" @newImageSrc="onNewPopImage" :showButton="false" buttonsClass="crop-buttons"></upload-image>
        </b-modal>

        <b-modal ref="modal-pop-style-select" id="modal-pop-style-select"  title="Select Form Style" size="lg" :hide-footer="true" no-close-on-esc no-close-on-backdrop hide-header-close>
            <div class="row">
              <div class="col">
                <p>Choose the style of form you want to create:</p>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <a href="javascript:;" @click="selectPopStyle(0)">
                  <img id="popStylePreview-0" alt="Simple Pop Up" class="w-100" src="/images/popup-thumbnails/popstyle-0.png" @click="selectPopStyle(0)" />
                  <label for="popStylePreview-0">Simple Pop Up</label>
                </a>
                <a  href="javascript:;" @click="selectPopStyle(1)">
                  <img id="popStylePreview-1" alt="Simple Pop Up" class="w-100" src="/images/popup-thumbnails/popstyle-1.png" @click="selectPopStyle(1)" />
                  <label for="popStylePreview-1">Pop Up with Image</label>
                </a>
                
              </div>
            </div>
        </b-modal>       
        <b-modal ref="modal-pop-style-1-options" id="modal-pop-style-1-options"  title="Select Popup Image" :hide-footer="true">

          OPTIONS

        </b-modal>
    </div>


</template>

<script>
  import axios from 'axios';
  import Noty from 'noty';

  import RenderHtml from "./RenderHtml.vue";

  import Verte from 'verte';
  import 'verte/dist/verte.css';


  import VSwatches from 'vue-swatches'
  import "vue-swatches/dist/vue-swatches.min.css"

  import VueColor from 'vue-color/src/components/Sketch.vue';


  import rangy from 'rangy';
  import 'rangy/lib/rangy-classapplier';

  import html2canvas from 'html2canvas';

  import CopyToClipboard from 'vue-copy-to-clipboard';

    export default {
      created() {
          var vm = this;
          window.onbeforeunload = function(){
              if(!vm.popupId){
                return "You have not saved your form - Are you sure you want to leave?";
              }else{
                return null;
              }
                 
          }
        },
        mounted() {
          var vm = this;
          vm.csrfToken = $('meta[name="csrf-token"]').attr('content');

          if(vm.popupId){
            vm.initBuilder();
          }else{
            //vm.popupelementsNavActive=false;
            vm.getDeckDefaults();

            vm.$refs['modal-pop-style-select'].show();

            vm.loadInitialTemplate();

          }
          this.isMounted = true;

          


        

        },
        updated(){
 
        },
        components: {
          'summernote' : require('summernote'),
           Verte,
           VSwatches,
           CopyToClipboard,
           'vue-color' : VueColor,
           'rendered': RenderHtml,
        },
        props: [
            'id',
            'sms_credit_value',
        ],
        data: function(){

            return {
                isMounted: false,

                popupId: this.id,

                popupName: 'Untitled',
                popupThankMsg: 'Thank You',
                popupCreateContact: true,
                popupOverwriteContact: true,
                popupSendDeck: null,
                popupSendDeckFrom: null,
                popupSendDeckVia: 'sms',

                companyUsers: [{value: null, text: 'Loading...'}],

                popupNotify: null,
                popupGDPR: 'By submitting your details you are giving us permission to send you communications via SMS.',
                popupRedirect: null,

                templateDecks: [{value: null, text: 'No, don\'t send a deck'}],

                deckBackground: null,
                deckHeadingFont: null,
                deckBodyFont: null,
                deckHeadingSize: null,
                deckBodySize: null,
                deckAccentColor: null,
                deckSecondaryColor: null,
                deckTertiaryColor: null,
                deckContrastColor: null,
                deckGroundColor: null,
                swatches: [],

                deckDefaults: [],

                tabActive: 'builder-tab',
                popupelementtemplatesnav:[],
                popupelementsNavActive: true,
                popupelementSettingsActive: false,
                popupelementSettingsActiveId: null,
                popupelementSettingsActiveRef: null,
                popupelementSettings:[],
                popupelements:[],

                newImageFromLib:'',

                editorSettingsSingleline:{
                  modules: {
                    toolbar: [
                      ['bold', 'italic', 'underline', 'strike'],[{ 'color': [] }, { 'background': [] }],  
                      [{ 'script': 'sub'}, { 'script': 'super' }],
                      ['link'],
                      ['clean'],
                    ],
                  },
                  blots: {
                    popupelement: []
                  }
                },

                editorSettingsMultiline:{},

                editingImage: false,

                disableSummernote: true,

                swatches: ['#F64272', '#F6648B', '#F493A7', '#F891A6', '#FFCCD5', ''],

                embedSettings: {
                  'delay':5000,
                  'autoclose':true,
                  'cookieClosed':0,
                  'cookieCompleted':30,
                  'position':'center-center',
                  'popstyle':0,
                  'popimg':'/images/default/girl-glasses.jpg'
                  }, // defaults

                popStylePreview: 0,

                showAdvancedSettings: false,

                extraCSS: null,

                sms_message: 'Hi [firstname fallback=there], here is the the information you requested.',
                email_subject: null,
                email_body: null,
                email_button: null,
                email_footer: null,

                geo_restrict: 'GB',

                sms_input_pos_start: 0,
                sms_input_pos_end: 0,

                embed_settings_initialised: false,

            }
        },

        methods: {

          leaving: function(){
            alert('leaving?');
          },

          loadInitialTemplate: async function () {
            var vm = this;
            await vm.selectPopupelement({type:'manual',popupelementTemplateId:'5',index:0});
            await vm.selectPopupelement({type:'manual',popupelementTemplateId:'3',index:1});
            await vm.selectPopupelement({type:'manual',popupelementTemplateId:'9',index:2});
            await vm.selectPopupelement({type:'manual',popupelementTemplateId:'4',index:3});
            
          },
          initBuilder: async function(){

            var vm = this;
            
            vm.getPopupSettings();

          },
          getDeckDefaults: function(){
            var vm = this;

            axios.get('/deck/defaults').then(response => {

              vm.deckDefaults = response.data;

              if(vm.deckBackground == null){      vm.deckBackground = response.data.background; }
              if(vm.deckHeadingFont == null){     vm.deckHeadingFont = response.data.heading_font; }
              if(vm.deckBodyFont == null){        vm.deckBodyFont = response.data.body_font; }
              if(vm.deckAccentColor == null){     vm.deckAccentColor = response.data.accent_color; }
              if(vm.deckSecondaryColor == null){  vm.deckSecondaryColor = response.data.secondary_color; }
              if(vm.deckTertiaryColor == null){   vm.deckTertiaryColor = response.data.tertiary_color; }
              if(vm.deckContrastColor == null){   vm.deckContrastColor = response.data.contrast_color; }
              if(vm.deckGroundColor == null){     vm.deckGroundColor = response.data.ground_color; }
              if(vm.deckBodySize == null){        vm.deckBodySize = response.data.body_size; }
              if(vm.deckHeadingSize == null){     vm.deckHeadingSize = response.data.heading_size; }

              vm.swatches = [];
              vm.swatches.push(vm.deckAccentColor);
              if(vm.deckSecondaryColor !== vm.deckAccentColor){ vm.swatches.push(vm.deckSecondaryColor); }
              if(vm.deckTertiaryColor !== vm.deckAccentColor && vm.deckTertiaryColor !== vm.deckSecondaryColor){ vm.swatches.push(vm.deckTertiaryColor); }
              vm.swatches.push(vm.deckContrastColor);
              vm.swatches.push(vm.deckGroundColor);

              vm.manageCompanyCards = response.data.manage_company_cards;             

              if(response.data.template_decks){
                vm.templateDecks = vm.templateDecks.concat(response.data.template_decks);
              }

              if(vm.popupSendDeckFrom == null){ vm.popupSendDeckFrom = response.data.user_id; }
              if(vm.popupSendDeck == '' && vm.templateDecks.length > 1){ vm.popupSendDeck = vm.templateDecks[1].value; }
              vm.companyUsers = response.data.company_users;

              vm.getPopupelementTemplates();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckDefaults'));

          },
          getPopupSettings: function(){

            var vm = this;

            axios.get('/form/settings/'+this.popupId).then(response => {

              if(response.data.name){vm.popupName = response.data.name;}
              if(response.data.thank_msg){vm.popupThankMsg = response.data.thank_msg;}
              if(typeof(response.data.create_contact) !== 'undefined'){
                if(response.data.create_contact){
                  vm.popupCreateContact = true;
                }else{
                  vm.popupCreateContact = false;
                }
              }
              if(typeof(response.data.overwrite_contact) !== 'undefined'){
                if(response.data.overwrite_contact){
                  vm.popupOverwriteContact = true;
                }else{
                  vm.popupOverwriteContact = false;
                }
              }
              if(response.data.send_deck){vm.popupSendDeck = response.data.send_deck;}
              if(response.data.user_id){vm.popupSendDeckFrom = response.data.user_id;}
              if(response.data.send_via){vm.popupSendDeckVia = response.data.send_via;}
              if(response.data.notify){vm.popupNotify = response.data.notify;}
              if(response.data.gdpr){vm.popupGDPR = response.data.gdpr;}
              if(response.data.redirect){vm.popupRedirect = response.data.redirect;}

              if(response.data.extra_css){vm.extraCSS = response.data.extra_css; vm.showAdvanced();}


              if(response.data.sms_message){vm.sms_message = response.data.sms_message;}
              if(response.data.email_subject){vm.email_subject = response.data.email_subject;}
              if(response.data.email_body){vm.email_body = response.data.email_body;}
              if(response.data.email_button){vm.email_button = response.data.email_button;}
              if(response.data.email_footer){vm.email_footer = response.data.email_footer;}

              if(response.data.embed_settings){
                vm.embedSettings = JSON.parse(response.data.embed_settings);
              }

              if(response.data.geo_restrict){vm.geo_restrict = response.data.geo_restrict;}

              if(typeof(response.data.geo_restrict) !== 'undefined'){

                if(response.data.geo_restrict){
                  vm.geo_restrict = response.data.geo_restrict;
                }else{
                  vm.geo_restrict = '';
                }
              }



              if(response.data.background){vm.deckBackground = response.data.background;}
         
              vm.getDeckDefaults();

            }).catch(() => console.warn('Oh. Something went wrong. getDeckSettings'));

          },
          initMediumEditor: function(){

            var vm = this; // access vue model

            var ParagraphButton = MediumEditor.Extension.extend({
              
              name: 'paragraph',

              init: function () {
                this.classApplier = rangy.createClassApplier('p', {
                    elementTagName: 'p',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.innerHTML = '<i class="icon-paragraph"></i>';
                this.button.title = 'Body Text';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                this.base.execAction('append-p');
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'p'){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var JumboParagraphButton = MediumEditor.Extension.extend({
              
              name: 'jumboparagraph',

              init: function () {
                this.classApplier = rangy.createClassApplier('p', {
                    elementTagName: 'p',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.innerHTML = '<i class="fa fa-header"><sup>6</sup></i>';
                this.button.title = 'XS Numbers';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                this.base.execAction('append-p');
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'p'){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var AccentColorButton = MediumEditor.Extension.extend({
              
              name: 'accentcolor',

              init: function () {
                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-accent-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>1</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));

              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierSecondary.isAppliedToSelection()){
                  this.classApplierSecondary.toggleSelection();
                }else{
                  this.classApplierSecondary.toggleSelection();
                  this.classApplierSecondary.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierTertiary.isAppliedToSelection()){
                  this.classApplierTertiary.toggleSelection();
                }else{
                  this.classApplierTertiary.toggleSelection();
                  this.classApplierTertiary.toggleSelection();
                }
                
                this.classApplierAccent.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierAccent.isAppliedToSelection()){
                  this.button.parentNode.parentNode.children.forEach(function(item){
                    let btn = item.firstChild;
                    if(btn.classList.contains('company-color-button')){
                      btn.classList.remove('medium-editor-button-active');
                    }
                  });
                  this.setActive();
                }else{this.setInactive();} // Set Button active/inactive
              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('accent')){
                  return true;
                }else{
                  return false;
                }
                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var SecondaryColorButton = MediumEditor.Extension.extend({
              
              name: 'secondarycolor',

              init: function () {

                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-secondary-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>2</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {
                
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierAccent.isAppliedToSelection()){
                  this.classApplierAccent.toggleSelection();
                }else{
                  this.classApplierAccent.toggleSelection();
                  this.classApplierAccent.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierTertiary.isAppliedToSelection()){
                  this.classApplierTertiary.toggleSelection();
                }else{
                  this.classApplierTertiary.toggleSelection();
                  this.classApplierTertiary.toggleSelection();
                }
                
                this.classApplierSecondary.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierSecondary.isAppliedToSelection()){
                  this.button.parentNode.parentNode.children.forEach(function(item){
                    let btn = item.firstChild;
                    if(btn.classList.contains('company-color-button')){
                      btn.classList.remove('medium-editor-button-active');
                    }
                  });
                  this.setActive();
                }else{this.setInactive();} // Set Button active/inactive

              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('secondary')){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });

            var TertiaryColorButton = MediumEditor.Extension.extend({
              
              name: 'tertiarycolor',

              init: function () {
                this.classApplierAccent = rangy.createClassApplier('accent', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierSecondary = rangy.createClassApplier('secondary', {
                    elementTagName: 'span',
                    normalize: true
                });
                this.classApplierTertiary = rangy.createClassApplier('tertiary', {
                    elementTagName: 'span',
                    normalize: true
                });

                this.button = this.document.createElement('button');
                this.button.classList.add('medium-editor-action');
                this.button.classList.add('company-color-button');
                this.button.classList.add('company-tertiary-color-button');
                this.button.innerHTML = '<i class="fa fa-tint"><sup>3</sup></i>';
                this.button.title = 'Company Colour';

                this.on(this.button, 'click', this.handleClick.bind(this));
              },

              getButton: function () {
                return this.button;
              },

              handleClick: function (event) {

                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierAccent.isAppliedToSelection()){
                  this.classApplierAccent.toggleSelection();
                }else{
                  this.classApplierAccent.toggleSelection();
                  this.classApplierAccent.toggleSelection();
                }
                // If color is applied then toggle else, toggle twice in case it's contained in selection.
                if(this.classApplierSecondary.isAppliedToSelection()){
                  this.classApplierSecondary.toggleSelection();
                }else{
                  this.classApplierSecondary.toggleSelection();
                  this.classApplierSecondary.toggleSelection();
                }
                
                this.classApplierTertiary.toggleSelection();
                
                this.base.checkContentChanged();
                if(this.classApplierTertiary.isAppliedToSelection()){
                  this.button.parentNode.parentNode.children.forEach(function(item){
                    let btn = item.firstChild;
                    if(btn.classList.contains('company-color-button')){
                      btn.classList.remove('medium-editor-button-active');
                    }
                  });
                  this.setActive();
                }else{this.setInactive();} // Set Button active/inactive

              },

              isAlreadyApplied: function (node) {

                if(node.nodeName.toLowerCase() === 'span' && node.classList.contains('tertiary')){
                  return true;
                }else{
                  return false;
                }

                
              },

              isActive: function () {
                return this.button.classList.contains('medium-editor-button-active');
              },

              setInactive: function () {
                this.button.classList.remove('medium-editor-button-active');
              },

              setActive: function () {
                this.button.classList.add('medium-editor-button-active');
              }

            });


            var useAccentcolor = 'accentcolor';
            var useSecondarycolor = 'secondarycolor';
            var useTertiarycolor = 'tertiarycolor';

            if(this.deckSecondaryColor == this.deckAccentColor){ 
              useSecondarycolor = ''; // If Secondary == Accent Color, then hide button
            }
            if(this.deckTertiaryColor == this.deckAccentColor || this.deckTertiaryColor == this.deckSecondaryColor){ 
              useTertiarycolor = ''; // If Tertiary == Accent Color || Secondary, then hide button
            }

            var inlineEditorForText = new MediumEditor('.editableText',{
                forcePlainText: true,
                buttonLabels: 'fontawesome',
                toolbar: {
                  buttons: [
                    { // Bold
                      name: 'bold',
                      aria: 'Bold',
                    }, 
                    { // Italic
                      name: 'italic',
                      aria: 'Italic',
                    }, 
                    { // Italic
                      name: 'underline',
                      aria: 'Underline',
                    }, 
                    {
                      name: 'anchor',
                      aria: 'Link',
                    },
                    'paragraph',
                    { // Heading
                      name: 'h1',
                      action: 'append-h3',
                      aria: 'Headline Large',
                      tagNames: ['h3'],
                      contentDefault: '<b>H1</b>',
                      classList: ['custom-class-h1'],
                      attrs: {
                          'data-custom-attr': 'attr-value-h1'
                      }
                    },            
                    { // Subheading
                        name: 'h2',
                        action: 'append-h4',
                        aria: 'Headline Medium',
                        tagNames: ['h4'],
                        contentDefault: '<b>H2</b>',
                        classList: ['custom-class-h2'],
                        attrs: {
                            'data-custom-attr': 'attr-value-h2'
                        }
                    },          
                    { // Large Text
                      name: 'h3',
                      action: 'append-h5',
                      aria: 'Headline Small',
                      tagNames: ['h5'],
                      contentDefault: '<b>H3</b>',
                      classList: ['custom-class-h3'],
                      attrs: {
                          'data-custom-attr': 'attr-value-h3'
                      }
                    },
                    useAccentcolor,
                    useSecondarycolor,
                    useTertiarycolor,
                    {
                      name: 'unorderedlist',
                      aria: 'Bullet Point List',
                    },
                    {
                      name:'orderedlist',
                      aria: 'Numbered List',
                    },
                    {
                      name:'justifyLeft', 
                      aria:'Left Aligned Text'
                    },
                    {
                      name:'justifyCenter', 
                      aria:'Centered Text'
                    },
                    {
                      name:'justifyRight', 
                      aria:'Right Aligned Text'
                    },
                    {
                      name: 'removePopupat',
                      aria: 'Remove Text Popupatting',
                    },
                    ],
                  },
                  extensions: {
                    'paragraph': new ParagraphButton(),
                    'accentcolor': new AccentColorButton(),
                    'secondarycolor': new SecondaryColorButton(),
                    'tertiarycolor': new TertiaryColorButton()
                  },
                  placeholder: {
                    text: '' 
                  },  
                  targetBlank: true,
                  anchor: {
                      linkValidation: true
                  }
            });
            
            inlineEditorForText.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-popupelement').attr('data-popupelementIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.popupelements[index].current.find(popupelementSetting => popupelementSetting.reference == reference).content = html;  // Update the popupelements data object with new current content

            });

            inlineEditorForText.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });

            var inlineEditorForHeading = new MediumEditor('.editableHeading',{
              disableReturn: true,
              forcePlainText: true,
              buttonLabels: 'fontawesome',
              toolbar: {
                buttons: [
                  { // Bold
                    name: 'bold',
                    aria: 'Bold',
                  }, 
                  { // Italic
                    name: 'italic',
                    aria: 'Italic',
                  }, 
                  { // Italic
                    name: 'underline',
                    aria: 'Underline',
                  }, 
                  {
                    name: 'anchor',
                    aria: 'Link',
                  },
                  {
                    name: 'removePopupat',
                    aria: 'Remove Text Popupatting',
                  },
                  ],
              },
              placeholder: {
                text: '' 
              }
            });

            
            inlineEditorForHeading.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-popupelement').attr('data-popupelementIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.popupelements[index].current.find(popupelementSetting => popupelementSetting.reference == reference).content = html;  // Update the popupelements data object with new current content
              
            });     


            inlineEditorForHeading.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });


            var inlineEditorForJumbo = new MediumEditor('.editableJumbo',{
              forcePlainText: true,
              buttonLabels: 'fontawesome',
              toolbar: {
                buttons: [
                  { // Bold
                    name: 'bold',
                    aria: 'Bold',
                  }, 
                  { // Italic
                    name: 'italic',
                    aria: 'Italic',
                  }, 
                  { // Italic
                    name: 'underline',
                    aria: 'Underline',
                  }, 
                  {
                    name: 'anchor',
                    aria: 'Link',
                  },
                  { // Heading
                    name: 'h1',
                    action: 'append-h2',
                    aria: 'XXL Numbers',
                    tagNames: ['h2'],
                    contentDefault: '<b>H1</b>',
                    classList: ['custom-class-h1'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h1'
                    }
                  },            
                  { // Subheading
                      name: 'h2',
                      action: 'append-h3',
                      aria: 'XL Numbers',
                      tagNames: ['h3'],
                      contentDefault: '<b>H2</b>',
                      classList: ['custom-class-h2'],
                      attrs: {
                          'data-custom-attr': 'attr-value-h2'
                      }
                  },          
                  { // Large Text
                    name: 'h3',
                    action: 'append-h4',
                    aria: 'Large Numbers',
                    tagNames: ['h4'],
                    contentDefault: '<b>H3</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h3'
                    },          
                    },          
                  { // Large Text
                    name: 'h4',
                    action: 'append-h5',
                    aria: 'Medium Numbers',
                    tagNames: ['h5'],
                    contentDefault: '<b>H4</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h4'
                    },          
                    },          
                  { // Large Text
                    name: 'h5',
                    action: 'append-h6',
                    aria: 'Small Numbers',
                    tagNames: ['h6'],
                    contentDefault: '<b>H5</b>',
                    classList: ['custom-class-h3'],
                    attrs: {
                        'data-custom-attr': 'attr-value-h5'
                    }
                  },
                  'jumboparagraph',
                  'accentcolor',
                  {
                    name:'justifyLeft', 
                    aria:'Left Aligned Text'
                  },
                  {
                    name:'justifyCenter', 
                    aria:'Centered Text'
                  },
                  {
                    name:'justifyRight', 
                    aria:'Right Aligned Text'
                  },
                  {
                    name: 'removePopupat',
                    aria: 'Remove Text Popupatting',
                  },
                  ],
                },
                extensions: {
                  'jumboparagraph': new JumboParagraphButton(),
                  'accentcolor': new AccentColorButton(),
                  'secondarycolor': new SecondaryColorButton(),
                  'tertiarycolor': new TertiaryColorButton()
                },
                placeholder: {
                  text: '' 
                }
            });
            
            inlineEditorForJumbo.subscribe('blur', function (event, editable) { // Fire on blur

              var index = $(editable).closest('.editable-popupelement').attr('data-popupelementIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(editable).attr('data-reference');
              var html = $(editable).html();

              vm.popupelements[index].current.find(popupelementSetting => popupelementSetting.reference == reference).content = html;  // Update the popupelements data object with new current content

            });

            inlineEditorForJumbo.subscribe('focus', function (event, editable) { // Fire on focus
              vm.closeSettings();
            });


            /* Plain Text ie. inline but not medium */
            $('.editablePlainText').each(function(){
              $(this).attr('contentEditable', 'true');
            });

            $('#popupBuildArea').on('blur','.editablePlainText',function(event) {
              
              var index = $(this).closest('.editable-popupelement').attr('data-popupelementIndex');

              if(index==null){return;} // If we were too quick for the editor then return to prevent errors

              var reference = $(this).attr('data-reference');
              var html = $(this).html();

              vm.popupelements[index].current.find(popupelementSetting => popupelementSetting.reference == reference).content = html;  // Update the popupelements data object with new current content

            });
            $('#popupBuildArea').on('focus','.editablePlainText',function(event) {
              vm.closeSettings();
            });


          },
          initSummernoteEditor: function(){

            var vm = this;
            $('.summernoteTargetHeading').summernote({
                fontSizes: ['10', '11', '12', '14', '18', '24', '36', '48' , '64', '82', '140', '180', '224'],
                colorButton: {
                  foreColor: '#000000',
                  backColor: 'transparent',
                },
                toolbar: [
                    ['color', ['color']],
                    ['fontsize', ['fontsize']],
                    ['style', ['bold', 'italic', 'underline','clear']],
                    ['para', ['paragraph']],
                    ['insert', ['link']],
                    ['view', ['codeview']],
                ],

                callbacks: {
                  onBlur: function() {
                    vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update popupelementSetting
                    vm.updatePopupelementFromSettings(); // Update Popupelements
                  },
                  onChange: function() {
                    vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update popupelementSetting
                    vm.updatePopupelementFromSettings(); // Update Popupelements
                  },
                  onEnter: function(e) {
                    e.preventDefault();
                  },
                  onPaste: function (e) {
                      var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                      e.preventDefault();
                      document.execCommand('insertText', false, bufferText);
                  }
                }
            });
            $('.summernoteTargetText').summernote({
                fontSizes: ['10', '11', '12', '14', '18', '24', '36', '48' , '64', '82', '140'],
                colorButton: {
                  foreColor: '#000000',
                  backColor: 'transparent',
                },
                toolbar: [
                    ['color', ['color']],
                    ['fontsize', ['fontsize']],
                    ['style', ['bold', 'italic', 'underline','clear']],
                    ['para', ['ul', 'ol', 'paragraph']],
                    ['insert', ['link']],
                    ['view', ['codeview']],
                ],

                callbacks: {
                  onBlur: function() {
                    vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update popupelementSetting
                    vm.updatePopupelementFromSettings(); // Update Popupelements
                  },
                  onChange: function() {
                    vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == $(this).attr('data-reference')).html = $(this).summernote('code'); // Update popupelementSetting
                    vm.updatePopupelementFromSettings(); // Update Popupelements
                  },
                  onPaste: function (e) {
                    var bufferText = ((e.originalEvent || e).clipboardData || window.clipboardData).getData('Text');
                    e.preventDefault();
                    document.execCommand('insertText', false, bufferText);
                  }
                }
            });

          },
          destroySummernoteEditor: function(){           
            $('.summernoteTargetHeading,.summernoteTargetText').each(function(){
              $(this).summernote('destroy');
            });
          },
          destroyMediumEditor: function(){

            $('.medium-editor-element').each(function(index, el) {
              var mediumEditor = MediumEditor.getEditorFromElement($(el)[0]);
              if(mediumEditor !== null){
                 mediumEditor.destroy();
              }
              
            });

          },
          initInlineImage: function(){

            var vm = this;
            $('#popupBuildArea').on('click','.editableImage',function(){

              vm.closeSettings();
              vm.closePopupelementNav();

              vm.popupelementSettingsActiveId = $(this).closest('.editable-popupelement').attr('data-popupelementindex');
              vm.popupelementSettingsActiveRef = $(this).attr('data-reference');

              vm.$refs['modal-medialib-inline-image'].show();

            });
          },
          initInlineButton: function(){

            var vm = this;
            $('#popupBuildArea').on('click','.btn-sizzle',function(e){

              e.preventDefault();
              vm.closeSettings();
              vm.closePopupelementNav();

              var popupelementSettingsActiveId = $(this).closest('.editable-popupelement').attr('data-popupelementindex');

              vm.openSettings(popupelementSettingsActiveId);

            });

          },
          getPopupelements: function(){

              const url = `/form/`+ this.popupId +`/formelements`;

              var vm = this;

              axios.get(url).then(response => {

                if(response.data.length > 0){                

                response.data.forEach(function(popupelement){

                  // Insert content
                  var popupelementHtml = $('<div></div>').append(popupelement.popupelement_template.html); // Create a holder div for jQuery to work from.

                  popupelement.content = JSON.parse(popupelement.content);

                  if(popupelement.content !== null){
                  
                  popupelement.content.forEach(function(item, index){

                    if(item.type == 'singleline' || item.type == 'multiline' || item.type == 'plaintext' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').html(item.content);
                    }
                    
                    if(item.type == 'image' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                      if(typeof item.link !== 'undefined'){ // if has link then set
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('data-href',item.link); 
                      }
                    }

                    if(item.type == 'avatar' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }

                    if(item.type == 'video' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }

                    if(item.type == 'background' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.color);

                      if(item.image){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-image',"url('"+item.image+"')"); // Update the color
                      }else{
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-image',''); // Update the color
                      }

                      popupelementHtml.find('[data-reference="' + item.reference + '"]').removeClass(function (index, css) {
                        return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                      }).addClass('skin-'+item.skin);

                    }

                    if(item.type == 'button' ){

                      if(typeof item.link !== 'undefined'){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                      }
                      if(typeof item.text !== 'undefined'){
                        let fullText = item.text;
                        if(typeof item.textprepend !== 'undefined'){ fullText = item.textprepend+fullText;}
                        if(typeof item.textappend !== 'undefined'){ fullText = fullText+item.textappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').html(fullText);                      
                      }
                      if(typeof item.color !== 'undefined'){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('color',item.color);
                      }
                      if(typeof item.background !== 'undefined'){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.background);     
                      }

                    }

                    if(item.type == 'showhide' ){

                      // Convert to bool
                      if(item.state === 'false'){ // Convert to bool
                        item.state = false;
                      }
                      if(item.state === 'true'){ // Convert to bool
                        item.state = true;
                      }

                      if(item.state===false){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').addClass('d-none');
                      }else{
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').removeClass('d-none');
                      }
                      
                    }

                    if(item.type == 'link' ){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                    }

                    if(item.type == 'input-select' ){
                    
                      popupelementHtml.find('[data-reference="' + item.reference + '"] select').attr('name',item.uid);
                      popupelementHtml.find('[data-reference="' + item.reference + '"] select').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"] select').attr('readonly',true);

                      let placeholder = item.placeholder;
                        
                          popupelementHtml.find('[data-reference="' + item.reference + '"] select')
                                 .append($("<option></option>")
                                            .attr("value", '')
                                            .text(placeholder)); 
                        
                        

                        let content = item.content;
                        content = content.trim();
                        let contentArr = content.split(/\n/);

                        var selectValues = []
                        for (var i=0; i < contentArr.length; i++) {
                          if (/\S/.test(contentArr[i])) {   // only push this line if it contains a non whitespace character.
                            selectValues.push($.trim(contentArr[i]));
                          }
                        }

                        $.each(selectValues, function(key, value) {   
                             popupelementHtml.find('[data-reference="' + item.reference + '"] select')
                                 .append($("<option></option>")
                                            .attr("value", value)
                                            .text(value)); 
                        });

                    }
                    if(item.type == 'input-text' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('name',item.uid);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('value',item.content);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }
                    if(item.type == 'input-textarea' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('name',item.uid);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').text(item.content); // Textarea
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }

                    /* Special Inputs */
                    if(item.type == 'input-firstname' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }
                    
                    if(item.type == 'input-lastname' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }
                    
                    if(item.type == 'input-companyname' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }

                    if(item.type == 'input-email' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }
                    
                    if(item.type == 'input-telephone' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',item.placeholder);
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').text(item.placeholder);

                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',item.required);

                      // 'Fake' Tel Styles
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').addClass('fake-tel-input');
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('tabindex',-1);

                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('readonly',true);
                    }
                    

                  });
                  
                  }


                  vm.popupelements.push({
                    popupelementTemplateId: popupelement.template_popupelement_id,
                    html: popupelementHtml.html(),
                    editable: popupelement.popupelement_template.editable,
                    current: popupelement.content
                  });                 

                });

                }

                Vue.nextTick(function(){
                  vm.initMediumEditor();
                  vm.initInlineImage();
                  vm.initInlineButton();
                });

              }).catch(() => console.warn('Oh. Something went wrong. getPopupelements'));

          },
          getPopupelementTemplates: function(getpopupelements=true){
                
            const url = `/form/formelement-templates`;
            var vm = this;
            axios.get(url).then(response => {

                vm.popupelementtemplatesnav = response.data;  
                if(vm.popupId && getpopupelements){
                  vm.getPopupelements();
                }
                

            }).catch(() => console.warn('Oh. Something went wrong. getPopupelementTemplates'));

          },
          togglePopupelements: function(){             
                this.popupelementsNavActive = !this.popupelementsNavActive;
                this.closeSettings();
          },
          closePopupelementNav: function(){             
                this.popupelementsNavActive = false;
          },
          scrollPopupelementNav: function(popupelementNavId){
            var vm = this;
            var popupelementsNav = vm.$el.querySelector("#popupelementsNav");
            var targetNav = vm.$el.querySelector('#accordion_'+popupelementNavId+'_button');
            popupelementsNav.scrollTop = targetNav.offsetTop;

          },
          selectPopupelement: async function(event){

              this.closeSettings();

              var vm = this;

              switch(event.type){

                case 'manual':
                  var popupelementTemplateId = event.popupelementTemplateId;
                  var newIndex = event.index;
                break;
                case 'click':
                  var popupelementTemplateId = $(event.currentTarget).attr('data-popupelementTemplateId');
                  var newIndex = this.popupelements.length;
                break;
                case 'add':
                  var popupelementTemplateId = event.item.attributes["data-popupelementtemplateid"].value;
                  var newIndex = event.newIndex;
                break;

              }

                const url = `/form/formelement-template/` + popupelementTemplateId;

                

                var deckDefaults = this.deckDefaults;

                await axios.get(url).then(response => {


                  // Insert Defaults
                  var popupelementHtml = $('<div></div>').append(response.data.html); // Create a holder div for jQuery to work from.

                  if(response.data.editable !== null){

                  response.data.editable.forEach(function(item, index){
                    if(item.type == 'singleline' || item.type == 'multiline' || item.type == 'plaintext' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').html(item.content);
                    }
                    if(item.type == 'image' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                      if(typeof item.link !== 'undefined'){ // if has link then set
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('data-href',item.link); 
                      }
                    }
                    if(item.type == 'avatar' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'video' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('src',item.content);
                    }
                    if(item.type == 'background' ){
                      popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.color);

                      if(item.image){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-image',"url('"+item.image+"')"); // Update the color
                      }else{
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-image',''); // Update the color
                      }

                      popupelementHtml.find('[data-reference="' + item.reference + '"]').removeClass(function (index, css) {
                        return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                      }).addClass('skin-'+item.skin);

                    }
                    if(item.type == 'button' ){
                      if(typeof item.link !== 'undefined'){

                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);

                      }
                      if(typeof item.text !== 'undefined'){
                        let fullText = item.text;
                        if(typeof item.textprepend !== 'undefined'){ fullText = item.textprepend+fullText;}
                        if(typeof item.textappend !== 'undefined'){ fullText = fullText+item.textappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').html(fullText);
                      }
                      if(typeof item.color !== 'undefined'){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('color',item.color);
                      }
                      if(typeof item.background !== 'undefined'){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').css('background-color',item.background);                      
                      }
                      
                    }
                    if(item.type == 'showhide' ){

                      // Convert to bool
                      if(item.state === 'false'){ // Convert to bool
                        item.state = false;
                      }
                      if(item.state === 'true'){ // Convert to bool
                        item.state = true;
                      }

                      if(item.state===false){
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').addClass('d-none');
                      }else{
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').removeClass('d-none');
                      }

                    }

                    if(item.type == 'link' ){
                        let fullLink = item.link;
                        if(typeof item.linkprepend !== 'undefined'){ fullLink = item.linkprepend+fullLink;}
                        if(typeof item.linkappend !== 'undefined'){ fullLink = fullLink+item.linkappend; }
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('href',fullLink);
                    }


                    /* Pop Up Elements Start */
                    if(item.type == 'input-select' ){
                      
                        
                        
                        let uid = vm.uuid; //item.uid;
                        popupelementHtml.find('[data-reference="' + item.reference + '"] select').attr('name',uid);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"] select').attr('required',required);

                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"] select')
                                 .append($("<option></option>")
                                            .attr("value", '')
                                            .text(placeholder)); 
                        
                        

                        let content = item.content;
                        content = content.trim();
                        let contentArr = content.split(/\n/);

                        var selectValues = []
                        for (var i=0; i < contentArr.length; i++) {
                          if (/\S/.test(contentArr[i])) {   // only push this line if it contains a non whitespace character.
                            selectValues.push($.trim(contentArr[i]));
                          }
                        }

                        $.each(selectValues, function(key, value) {   
                             popupelementHtml.find('[data-reference="' + item.reference + '"] select')
                                 .append($("<option></option>")
                                            .attr("value", value)
                                            .text(value)); 
                        });

                        
                    }
                    if(item.type == 'input-text' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let uid = vm.uuid; //item.uid;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('name',uid);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('value',content);
                    }
                    if(item.type == 'input-textarea' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let uid = item.uid;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('name',uid);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').text(content);
                    }
                    if(item.type == 'input-firstname' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                    }
                    if(item.type == 'input-companyname' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                    }
                    if(item.type == 'input-lastname' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                    }
                    if(item.type == 'input-email' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                    }
                    if(item.type == 'input-telephone' ){
                        let placeholder = item.placeholder;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('placeholder',placeholder);
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').text(placeholder);
                        let required = item.required;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('required',required);
                        let content = item.content;
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').addClass('fake-tel-input');
                        popupelementHtml.find('[data-reference="' + item.reference + '"]').attr('tabindex',-1);
                    }
                    /* Pop Up Elements End */




                  });

                  }

                  response.data.html = popupelementHtml.html()



                  response.data.current = vm.copyObject(response.data.editable); // make a (non-reactive) copy of editable for current

                  // Replace User Placeholders
                  for (var prop in deckDefaults) {
                    if(deckDefaults[prop] == null){ deckDefaults[prop] = '';} // Replace word null with blank
                    response.data.html = response.data.html.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);


                    if(response.data.current !== null){
                    response.data.current.forEach(function(item,index){

                      switch(item.type){
                        case 'background':
                          if(typeof response.data.current[index].color !== 'undefined' && response.data.current[index].color !== null){
                            response.data.current[index].color = response.data.current[index].color.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].image !== 'undefined' && response.data.current[index].image !== null){
                            response.data.current[index].image = response.data.current[index].image.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }

                        break;
                        case 'button':
                          if(typeof response.data.current[index].link !== 'undefined' && response.data.current[index].link !== null){
                            response.data.current[index].link = response.data.current[index].link.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].text !== 'undefined' && response.data.current[index].text !== null){
                            response.data.current[index].text = response.data.current[index].text.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].color !== 'undefined' && response.data.current[index].color !== null){
                            response.data.current[index].color = response.data.current[index].color.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }
                          if(typeof response.data.current[index].background !== 'undefined' && response.data.current[index].background !== null){
                            response.data.current[index].background = response.data.current[index].background.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          }


                          if(
                            typeof response.data.current[index].showhide !== 'undefined' && 
                            typeof response.data.current[index].link !== 'undefined'
                          ){
                            if(response.data.current[index].link == ''){ 
                              
                                popupelementHtml = $('<div></div>').append(response.data.html); // Convert back to jQuery object
                                popupelementHtml.find('[data-reference="' + response.data.current[index].showhide + '"]').addClass('d-none'); // do find replace
                                response.data.html = popupelementHtml.html() // reconvert to html
                                response.data.current.find(popupelementSetting => popupelementSetting.reference == response.data.current[index].showhide).state = false;
                              
                            }
                          }



                        break;
                        case 'showhide':
                        break;
                        case 'link':
                          response.data.current[index].link = response.data.current[index].link.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);

                          if(
                            typeof response.data.current[index].showhide !== 'undefined' && 
                            typeof response.data.current[index].link !== 'undefined'
                          ){
                            if(response.data.current[index].link == ''){ 
                              
                                popupelementHtml.find('[data-reference="' + response.data.current[index].showhide + '"]').addClass('d-none');
                                response.data.html = popupelementHtml.html()
                                response.data.current.find(popupelementSetting => popupelementSetting.reference == response.data.current[index].showhide).state = false;
                              
                            }
                          }

                        break;
                        /* Pop Up Elements Start */
                        case 'input-select':
                          if(prop == 'uuid'){ response.data.current[index].uid = response.data.current[index].uid.replace(new RegExp('{'+ prop +'}', 'gi'), Date.now().toString(36) + Math.random().toString(36).substr(2));}
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          if(response.data.current[index].content !== null){response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);}
                        break;
                        case 'input-text':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          if(prop == 'uuid'){ response.data.current[index].uid = response.data.current[index].uid.replace(new RegExp('{'+ prop +'}', 'gi'), Date.now().toString(36) + Math.random().toString(36).substr(2));}
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          if(response.data.current[index].content !== null){response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);}
                        break;
                        case 'input-textarea':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          if(prop == 'uuid'){ response.data.current[index].uid = response.data.current[index].uid.replace(new RegExp('{'+ prop +'}', 'gi'), Date.now().toString(36) + Math.random().toString(36).substr(2));}
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          if(response.data.current[index].content !== null){response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);}
                        break;
                        case 'input-firstname':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                        case 'input-lastname':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                        case 'input-companyname':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                        case 'input-email':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                        case 'input-telephone':
                          response.data.current[index].placeholder = response.data.current[index].placeholder.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].required = response.data.current[index].required.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                        /* Pop Up Elements End */
                        default:
                          response.data.current[index].content = response.data.current[index].content.replace(new RegExp('{'+ prop +'}', 'gi'), deckDefaults[prop]);
                        break;
                      }

                    });
                    } 

                  }
                
                  vm.popupelements.splice(newIndex,0,{
                    popupelementTemplateId: popupelementTemplateId,
                    html: response.data.html,
                    editable: response.data.editable,
                    current: response.data.current
                  });                 

                Vue.nextTick(function(){
                  vm.destroyMediumEditor();
                  // Init MediumEditor
                  vm.initMediumEditor();
                  if(event.type == 'click'){           
                    // Scroll to the bottom
                    var builderContainer = vm.$el.querySelector("#popupBuilderContainer");
                    builderContainer.scrollTop = builderContainer.scrollHeight;
                  }
                });
                
                  return;

                }).catch(() => console.warn('Oh. Something went wrong. selectPopupelement'));                
          },
          initClonePopupelement: function(value){
            
            var vm = this;

            vm.destroyMediumEditor();   // Unload Medium Editor - VERY IMPORTANT` `
            vm.closeSettings();
            vm.updatePopupelementsFromInline();
            
            Vue.nextTick(function(){
              vm.initMediumEditor();
            });

            return;  // Important we return nothing here so we don't add to popupelements array
          },
          removePopupelement: function (index) {
              
              var vm = this;

              this.closeSettings();

            this.$bvModal.msgBoxConfirm('Are you sure you want to remove this element?')
              .then(value => {
                if(value){

                  vm.destroyMediumEditor();  // Unload Medium Editor - VERY IMPORTANT
                  vm.updatePopupelementsFromInline();

                  this.popupelements.splice(index, 1);

                  Vue.nextTick(function(){
                    vm.initMediumEditor();
                  });

                }
              })
              .catch(err => {
                // An error occurred
              })

          },
          copyObject: function(o) {
            var vm = this;
            if (o === null){ return null; }

            var output, v, key;
            output = Array.isArray(o) ? [] : {};
            for (key in o) {
                v = o[key];
                output[key] = (typeof v === "object") ? vm.copyObject(v) : v;
            }
            return output;
          },
          duplicatePopupelement: function (index) {

            var vm = this;

            vm.destroyMediumEditor();
            vm.updatePopupelementsFromInline();
            vm.closeSettings();

            var newIndex = index+1;
            var newPopupelement = vm.popupelements[index];


            vm.popupelements.splice(newIndex,0,Object.assign({},vm.copyObject(newPopupelement)));

            Vue.nextTick(function(){
              vm.initMediumEditor();
            });


          },
          movePopupelementUp: async function (index) {

            var vm = this;

            if(index != 0){
              
              vm.destroyMediumEditor();
              vm.updatePopupelementsFromInline();
              vm.closeSettings();

              var popupelement = vm.popupelements[index];
              var swapPopupelement = vm.popupelements[index - 1];
              
              var popupelements = vm.popupelements;
              vm.popupelements = [];
              popupelements.splice(index,1,swapPopupelement);
              popupelements.splice(index - 1,1,popupelement);
              
              await this.$nextTick(); // Wait for dom to update to avoid display issues with newly duplicated popupelements

              vm.popupelements = popupelements;

              await this.$nextTick();

              vm.initMediumEditor();

            }

          },
          movePopupelementDown: async function (index) {
            var vm = this;

            if(index < (vm.popupelements.length -1)){
              vm.destroyMediumEditor();  // Unload Medium Editor - VERY IMPORTANT
              vm.updatePopupelementsFromInline();
              vm.closeSettings();

              var popupelement = vm.popupelements[index];
              var swapPopupelement = vm.popupelements[index + 1];

              var popupelements = vm.popupelements;
              vm.popupelements = [];
              popupelements.splice(index,1,swapPopupelement);
              popupelements.splice(index + 1,1,popupelement);
              
              await this.$nextTick(); // Wait for dom to update to avoid display issues with newly duplicated popupelements

              vm.popupelements = popupelements;

              await this.$nextTick();

              vm.initMediumEditor();

            }
          },
          openSettings: function (index) {



            // Close popupelementsnav
            this.popupelementsNavActive = false;

            this.destroySummernoteEditor();              

            // Close and clear settings if required
            this.popupelementSettings = [];
            this.popupelementSettingsActive = false;
            
            var vm = this; // Pass view model to function

            this.popupelements[index].current.forEach(function(item){                

              

              // Setup settings window and pass current html - will need to have if statements on this for images and video
              switch(item.type) {
                case 'image':

                  let imgobj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    image: item.content
                  };

                  if(typeof item.link !== 'undefined'){
                    imgobj.link = item.link;
                  }

                  vm.popupelementSettings.push(imgobj);
                  break;
                case 'background':
                  if(item.color == 'accent'){item.color = vm.deckAccentColor;}
                  if(item.color == null){item.color = vm.deckGroundColor;}
                  if(item.color == 'ground'){item.color = vm.deckGroundColor;}

                  vm.popupelementSettings.push({
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    color: item.color,
                    image: item.image,
                    skin: item.skin
                  });
                  break;
                case 'avatar':
                  vm.popupelementSettings.push({
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    image: item.content
                  });
                  break;
                case 'video':
                  vm.popupelementSettings.push({
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    video: item.content
                  });
                  break;
                case 'button':

                  let btnobj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                  };

                  if(typeof item.link !== 'undefined'){
                  
                    if(typeof item.linklabel !== 'undefined'){
                      btnobj.linklabel = item.linklabel;
                    }   
                    if(typeof item.linkprepend !== 'undefined'){
                      btnobj.linkprepend = item.linkprepend;
                    }                  
                    if(typeof item.linkappend !== 'undefined'){
                      btnobj.linkappend = item.linkappend;
                    }

                    btnobj.link = item.link;
                  }

                  if(typeof item.text !== 'undefined'){

                    if(typeof item.textprepend !== 'undefined'){
                      btnobj.textprepend = item.textprepend;
                    }                  
                    if(typeof item.textappend !== 'undefined'){
                      btnobj.textappend = item.textappend;
                    }

                    btnobj.text = item.text;
                  }
                  if(typeof item.color !== 'undefined'){
                    if(item.color == 'accent'){item.color = vm.deckAccentColor;}
                    if(item.color == 'ground'){item.color = vm.deckGroundColor;}
                    btnobj.color = item.color;
                  }
                  if(typeof item.background !== 'undefined'){
                    if(item.background == 'accent'){item.background = vm.deckAccentColor;}
                    if(item.background == 'ground'){item.background = vm.deckGroundColor;}
                    btnobj.background = item.background;
                  }

                  vm.popupelementSettings.push(btnobj);
                  break;
                case 'showhide':

                  if(item.state === 'false'){ // Convert to bool
                    item.state = false;
                  }
                  if(item.state === 'true'){ // Convert to bool
                    item.state = true;
                  }

                  vm.popupelementSettings.push({
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    state: item.state
                  });
                  break;

                case 'link':

                  let linkobj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    link: item.link
                  };


                  if(typeof item.linklabel !== 'undefined'){
                    linkobj.linklabel = item.linklabel;
                  }

                  if(typeof item.linkprepend !== 'undefined'){
                      linkobj.linkprepend = item.linkprepend;
                  }                  
                  if(typeof item.linkappend !== 'undefined'){
                      linkobj.linkappend = item.linkappend;
                  }

                  vm.popupelementSettings.push(linkobj);
                  break;

                case 'input-select':

                  let input_select_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    uid: item.uid,
                    required: item.required,
                    content: item.content,
                    placeholder: item.placeholder
                  };
                  vm.popupelementSettings.push(input_select_obj);

                break
                case 'input-text':

                  let input_text_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    uid: item.uid,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_text_obj);

                break
                case 'input-textarea':

                  let input_textarea_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    uid: item.uid,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_textarea_obj);

                break
                case 'input-firstname':

                  let input_firstname_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_firstname_obj);

                break
                case 'input-lastname':

                  let input_lastname_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_lastname_obj);

                break
                case 'input-companyname':

                  let input_companyname_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_companyname_obj);

                break
                case 'input-email':

                  let input_email_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    required: item.required,
                    content: item.content
                  };                
                  vm.popupelementSettings.push(input_email_obj);

                break
                case 'input-telephone':

                  let input_telephone_obj = {
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    placeholder: item.placeholder,
                    required: item.required,
                    content: item.content
                  };                

                  vm.popupelementSettings.push(input_telephone_obj);

                break

                default:
                  vm.popupelementSettings.push({
                    popupelementIndex: index,
                    type: item.type,
                    label: item.label,
                    reference: item.reference,
                    html: item.content
                  });
              }            


            });

            // Open the settings window
            this.popupelementSettingsActive = true;
            
            this.popupelementSettingsActiveId = index;

            Vue.nextTick(function(){vm.initSummernoteEditor()});

          },
          onNewImageSrc:function(data){        
            var vm = this;
                vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == data.reference).image = data.src; // Update popupelementSetting
                vm.updatePopupelementFromSettings(); // Update Popupelements
          },
          onEditingImage:function(data){  
            this.editingImage = data;
          },
          removePopupelementSettingImage: function(reference){
            var vm = this;
                vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).image = ''; // Update popupelementSetting
                vm.updatePopupelementFromSettings(); // Update Popupelements
          },
          updateVideo: function(reference){
                       
            var videoUrl = $('.builder-popupelement-settings').find('[data-reference="' + reference + '"]').val();
            var match_found = false;
            
            // First, check for youtube video            
            var videoID = videoUrl.match(/(?:http(?:s|):|)\/\/(?:www\.|)yout(?:.*?)\/(?:embed\/|watch.*?v=|)([a-z_A-Z0-9\-]{11})/);

            if (videoID) {
                var videoID = videoID[1];
                videoUrl = 'https://www.youtube.com/embed/'+videoID+'/?rel=0'; // Popupat for YT embed URL
                match_found = true;
            }

            // Then check for Vimeo
            if(!match_found){
              videoID = videoUrl.match(/(?:https?:\/\/)?(?:www.)?(?:player.)?vimeo.com\/(?:[a-z]*\/)*([0-9]{6,11})[?]?.*/);
              if (videoID) {
                  var videoID = videoID[1];
                  videoUrl = 'https://player.vimeo.com/video/'+videoID+'?title=0&byline=0&portrait=0'; // Popupat for Vimeo embed URL
                  match_found = true;
              }
            }
            

            if(match_found){
              var vm = this;
              vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).video = videoUrl; // Update popupelementSetting
              vm.updatePopupelementFromSettings(); // Update Popupelements
            }else{

              new Noty({
                        text: 'Oops that doesn\'t look like a valid Vimeo or YouTube link. Please check and try again.',
                        type: 'error',
                        theme: 'bootstrap-v4',
                        layout: 'topCenter',
                        timeout: 2000
                    }).show();
            }
            
          },
          closeSettings: function(){

            this.destroySummernoteEditor();

            // Close and clear settings window
            this.popupelementSettings = [];
            this.popupelementSettingsActive = false;

          },
          setVueColor: function(color,reference){

              var vm = this;
              vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).color = color.hex;
              vm.updatePopupelementFromSettings();

          },
          setVueBackground: function(color,reference){

              var vm = this;
              vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).background = color.hex;
              vm.updatePopupelementFromSettings();

          },
          swatchplusdefault: function(swatches,reference){

            var vm = this;

            var defaultcolors = [];
  
            if(typeof vm.popupelements[vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).popupelementIndex].editable.find(popupelementSetting => popupelementSetting.reference == reference).color !== 'undefined'){
              defaultcolors.push(vm.popupelements[vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).popupelementIndex].editable.find(popupelementSetting => popupelementSetting.reference == reference).color);
            }
            if(typeof vm.popupelements[vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).popupelementIndex].editable.find(popupelementSetting => popupelementSetting.reference == reference).background !== 'undefined'){
              defaultcolors.push(vm.popupelements[vm.popupelementSettings.find(popupelementSetting => popupelementSetting.reference == reference).popupelementIndex].editable.find(popupelementSetting => popupelementSetting.reference == reference).background);
            }

            var swatchcolors = defaultcolors.concat(swatches);

            swatchcolors = swatchcolors.filter(function(item) {
                if(item == 'accent' || item == 'ground'){
                  return false;
                }else{
                  return true;
                }
            });


            var uniqswatchcolors = [...new Set(swatchcolors)];

            return uniqswatchcolors;

          },
          updatePopupelementFromSettings: function(){

            var vm = this;

            this.popupelementSettings.forEach(function(popupelementSetting){

                var targetPopupelementHtml = $('<div></div>').append(vm.popupelements[popupelementSetting.popupelementIndex].html); // Grab the HTML of the popupelement in the popupelements for manipulation. Create a holder div for jQuery to work from.

                switch(popupelementSetting.type){
                  case 'singleline':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').html(popupelementSetting.html); // Update the html of the popupelement area we edited
                  break;
                  case 'multiline':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').html(popupelementSetting.html); // Update the html of the popupelement area we edited
                  break;
                  case 'plaintext':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').html(popupelementSetting.html); // Update the html of the popupelement area we edited
                  break;
                  case 'image':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('src',popupelementSetting.image); // Update the src of the popupelement image
                    if(typeof popupelementSetting.link !== 'undefined'){ // if has link then set
                      targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('data-href',popupelementSetting.link); 
                    }
                  break; 
                  case 'avatar':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('src',popupelementSetting.image); // Update the src of the popupelement image
                  break;
                  case 'video':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('src',popupelementSetting.video); // Update the src of the popupelement video
                  break;

                  case 'link':

                    let fullLink = popupelementSetting.link;
                    if(typeof popupelementSetting.linkprepend !== 'undefined'){ fullLink = popupelementSetting.linkprepend+fullLink;}
                    if(typeof popupelementSetting.linkappend !== 'undefined'){ fullLink = fullLink+popupelementSetting.linkappend; }
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('href',fullLink);

                  break;
                  case'showhide':
                      if(popupelementSetting.state==='false' || popupelementSetting.state===false){
                        targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').addClass('d-none');
                      }else{
                        targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').removeClass('d-none');
                      }
                  break;
                  case 'background':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').css('background-color',popupelementSetting.color); // Update the color

                    if(popupelementSetting.image){
                      targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').css('background-image',"url('"+popupelementSetting.image+"')"); // Update the color
                    }else{
                      targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').css('background-image',''); // Update the color
                    }

                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').removeClass(function (index, css) {
                      return (css.match (/\bskin-\S+/g) || []).join(' '); // removes anything that starts with "skin-"
                    }).addClass('skin-'+popupelementSetting.skin);
                    
                  break;
                  case 'button':
                  if(typeof popupelementSetting.link !== 'undefined'){

                    let fullLink = popupelementSetting.link;
                    if(typeof popupelementSetting.linkprepend !== 'undefined'){ fullLink = popupelementSetting.linkprepend+fullLink;}
                    if(typeof popupelementSetting.linkappend !== 'undefined'){ fullLink = fullLink+popupelementSetting.linkappend; }
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('href',fullLink);

                    
                  }
                  if(typeof popupelementSetting.text !== 'undefined'){

                    let fullText = popupelementSetting.text;
                    if(typeof popupelementSetting.textprepend !== 'undefined'){ fullText = popupelementSetting.textprepend+fullText;}
                    if(typeof popupelementSetting.textappend !== 'undefined'){ fullText = fullText+popupelementSetting.textappend; }
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').html(fullText);

                  }
                  if(typeof popupelementSetting.color !== 'undefined'){
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').css('color',popupelementSetting.color);        
                  }
                  if(typeof popupelementSetting.background !== 'undefined'){       
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').css('background-color',popupelementSetting.background);     
                  }
                  break;
                  case 'input-select':
                    
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"] select').attr('name',popupelementSetting.uid);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"] select').attr('required',popupelementSetting.required);

                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"] select option').remove(); // Remove existing

                    let placeholder = popupelementSetting.placeholder;
                      
                        targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"] select')
                               .append($("<option></option>")
                                          .attr("value", '')
                                          .text(placeholder)); 
                        

                    let content = popupelementSetting.content;
                        content = content.trim();
                        let contentArr = content.split(/\n/);

                        var selectValues = []
                        for (var i=0; i < contentArr.length; i++) {
                          if (/\S/.test(contentArr[i])) {   // only push this line if it contains a non whitespace character.
                            selectValues.push($.trim(contentArr[i]));
                          }
                        }

                        $.each(selectValues, function(key, value) {   
                             targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"] select')
                                 .append($("<option></option>")
                                            .attr("value", value)
                                            .text(value)); 
                        });


                  break
                  case 'input-text':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('name',popupelementSetting.uid);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-textarea':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').text(popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('name',popupelementSetting.uid);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-firstname':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    //targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-lastname':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    //targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-companyname':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    //targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-email':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    //targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break
                  case 'input-telephone':
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('placeholder',popupelementSetting.placeholder);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').text(popupelementSetting.placeholder);
                    //targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('value',popupelementSetting.content);
                    targetPopupelementHtml.find('[data-reference="' + popupelementSetting.reference + '"]').attr('required',popupelementSetting.required);
                  break

                }
                var updatedHTML = targetPopupelementHtml.html();

                // Remove the medium editor
                var mediumEditor = MediumEditor.getEditorFromElement($('[data-popupelementindex="' + popupelementSetting.popupelementIndex + '"] [data-reference="' + popupelementSetting.reference + '"]')[0]);
                if(mediumEditor !== null){
                  mediumEditor.destroy();
                }

                vm.popupelements[popupelementSetting.popupelementIndex].html = updatedHTML; // Update the popupelements data object

                switch(popupelementSetting.type){
                  case 'avatar':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.image;  
                  break;
                  case 'image':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.image;  
                    if(typeof popupelementSetting.link !== 'undefined'){ // If link is set then add to popupelementSetting
                      vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).link = popupelementSetting.link;
                    }
                    
                  break;
                  case 'video':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.video;  
                  break;
                  case 'showhide':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).state = popupelementSetting.state;  
                  break;

                  case 'link':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).link = popupelementSetting.link;  
                  break;
                  case 'background':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).color = popupelementSetting.color;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).image = popupelementSetting.image;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).skin = popupelementSetting.skin;  
                  break;
                  case 'button':
                    if(typeof popupelementSetting.link !== 'undefined'){
                      vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).link = popupelementSetting.link;  
                    }
                    if(typeof popupelementSetting.text !== 'undefined'){
                      vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).text = popupelementSetting.text;  
                    }
                    if(typeof popupelementSetting.color !== 'undefined'){
                      vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).color = popupelementSetting.color;  
                    }
                    if(typeof popupelementSetting.background !== 'undefined'){
                      vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).background = popupelementSetting.background;  
                    }
                  break;
                  case 'input-select':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).uid = popupelementSetting.uid;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                  break;
                  case 'input-text':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).uid = popupelementSetting.uid;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-textarea':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).uid = popupelementSetting.uid;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-firstname':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-lastname':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-companyname':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-email':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  case 'input-telephone':
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).placeholder = popupelementSetting.placeholder;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).required = popupelementSetting.required;  
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.content;  
                  break;
                  default:
                    vm.popupelements[popupelementSetting.popupelementIndex].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == popupelementSetting.reference).content = popupelementSetting.html;  
                }

            });

            Vue.nextTick(function(){vm.initMediumEditor()}); // Re-apply Medium Editor

          },          
          updatePopupelementsFromInline: function(){

              var vm = this;

              $('.popupbuilder-build-area').find('.editable-popupelement').each(function(index,editable) {

                  var reference = $(editable).attr('data-reference');
                  var html = $(editable).html();

                  vm.popupelements[index].html = html; // Update the popupelements data object with new HTML
                  
              });

          },
          onSetID: function(id){
            this.popupId = id;
          },

          onSetName: function(e){ 

                e.preventDefault();

                var deckname = this.$refs['set-popupname'].value;

                const url = `/form/store`;

                var vm = this;

                axios.post(url,{id:vm.popupId,name:deckname,background:vm.deckBackground}).then(response => {
                    
                      if(response.data.status == 'success'){

                        if(vm.popupId == ''){
                          vm.popupId = response.data.payload.id;

                          window.history.pushState("", "", "/form/edit/"+vm.popupId);

                          Vue.nextTick(function(){
                            vm.initBuilder();
                            vm.popupelementsNavActive=true;
                          });

                        }

                         
                        vm.deckName = response.data.payload.name;
                        
                        vm.$refs['set-deckname-modal'].hide();
                      
                        Appcues.page();
                      
                      }else{

                          new Noty({
                              text: response.data.message,
                              type: response.data.status,
                              theme: 'bootstrap-v4',
                              layout: 'topCenter',
                              timeout: 1000
                          }).show();

                      }

                }).catch( error => {

                      if(error.response.status == '419'){

                        new Noty({
                                text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();

                      }else{

                      new Noty({
                                text: 'There has been an error, please try saving again.',
                                type: 'error',
                                theme: 'bootstrap-v4',
                                layout: 'topCenter',
                                timeout: false
                            }).show();
                    }
              });

                
          },
          onCancelSetName: function(e){
            e.preventDefault();
            var vm = this;
            
            if(this.deckName !== ''){ 
              Vue.nextTick(function(){vm.$refs['set-deckname-modal'].hide();});
            }else{
              new Noty({
                      text: 'Please enter a deck title to continue.',
                      type: 'error',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 2000
                  }).show();
            }

          },
          launchBackgroundPop: function(e){
              this.$refs['choose-background-modal'].show();
          },
          launchOgImagePop: function(e){
              this.$refs['choose-ogimage-modal'].show();
          },
          launchSettingsPop: function(e){
              this.$refs['deck-settings-modal'].show();
          },
          onSelectedImageFromLibraryForBackground: function(background){

            const url = `/form/store`;

            axios.post(url,{id:this.popupId,background:background.src}).then(response => {
               this.deckBackground = background.src;
            }).catch(() => console.warn('Oh. Something went wrong'));
              
          },
          onSelectedImageFromLibraryForOgImage: function(image){

            const url = `/form/store`;

            axios.post(url,{id:this.popupId,og_image_static:image.src}).then(response => {
               this.staticOgImage = image.src;
               this.$refs['choose-ogimage-modal'].hide();
            }).catch(() => console.warn('Oh. Something went wrong'));

          },
          launchNamePop: function(){
              this.$refs['set-deckname-modal'].show()
          },
          launchTemplateDeckPop: function(){
              this.$refs['deck-settings-modal'].hide();
              this.$refs['template-deck-modal'].show();
          },
          savePopup: async function(event){

             if(event == 'preview-popup'){ // Call window open before Ajax to fix popup block on safari
                var windowReference = window.open();
              }

            var is_autosave = false;
            var vm = this;
            if(event == 'autosave'){is_autosave = true;}
            var first_save = false;
            if(!vm.popupId){first_save = true;}

            const builderTab = document.querySelector("#popupBuildArea");
            builderTab.classList.add("hidden-block"); // class sets visibilty:hidden,display:block,height:0 so screenshotTarget has height

            const screenshotTarget = document.querySelector("#popupBuildArea .draggable-area");

            screenshotTarget.classList.add("screenshot-in-progress");
            const url = `/form/savepopup`;

            html2canvas(screenshotTarget).then((canvas) => {

              const screenshot = canvas.toDataURL("image/png");

             

              axios.post(url,{
                'id':vm.popupId,
                'popupName':vm.popupName,
                'thank_msg':vm.popupThankMsg,
                'redirect':vm.popupRedirect,
                'create_contact':vm.popupCreateContact,
                'overwrite_contact':vm.popupOverwriteContact,
                'send_deck':vm.popupSendDeck,
                'send_via':vm.popupSendDeckVia,
                'user_id':vm.popupSendDeckFrom,
                'sms_message':vm.sms_message,
                'email_subject':vm.email_subject,
                'email_body':vm.email_body,
                'email_button':vm.email_button,
                'email_footer':vm.email_footer,
                'notify':vm.popupNotify,
                'gdpr':vm.popupGDPR,
                'redirect':vm.popupRedirect,
                'popupelements':vm.popupelements,
                'is_autosave':is_autosave,
                'screenshot':screenshot,
                'extra_css':vm.extraCSS,
                'embed_settings':vm.embedSettings,
                'geo_restrict':vm.geo_restrict,
              }).then(response => {
                builderTab.classList.remove("hidden-block");
                screenshotTarget.classList.remove("screenshot-in-progress");

                if(!response.data.status){
                    new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 2000
                      }).show();

                }else{

                    new Noty({
                          text: response.data.message,
                          type: response.data.status,
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: 1000
                      }).show();

                    if(response.data.status == 'success'){
                      vm.popupId = response.data.payload.id;
                      vm.popupName = response.data.payload.name;
                      if(first_save){window.history.pushState("", "", "/form/edit/"+vm.popupId);}
                      if(event == 'preview-popup'){
                        windowReference.location = '/form/preview-popup/'+vm.popupId;
                      }
                    }

                }
                
              }).catch( error => {

                builderTab.classList.remove("hidden-block");
                screenshotTarget.classList.remove("screenshot-in-progress");

                if(error.response.status == '419'){

                  new Noty({
                          text: 'You have been logged out due to inactivity. Please refresh this page to login.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show()

                }else{

                new Noty({
                          text: 'There has been an error, please try saving again.',
                          type: 'error',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false
                      }).show();

                }

                

              });

            });


          },
          initSend: function(event){
            this.saveDeck('send');
          },
          onSelectedImageFromLibrary: function(data){
            this.onNewImageSrc(data);
            this.$bvModal.hide('modal-medialib');
          },
          onSelectedImageFromLibraryForPopupelementBackground: function(data){
            this.onNewImageSrc(data);
            this.$bvModal.hide('modal-medialib-popupelementbackground');
          },
          onSelectedImageFromLibraryForAvatar: function(data){
            var vm = this;
            vm.newImageFromLib = data;
            this.$bvModal.hide('modal-medialib');
            this.$forceUpdate();
          },
          onSelectedImageFromLibraryForInlineImage: async function(data){

            var vm = this;

            vm.destroyMediumEditor(); // Must destroy Medium Editor first!!

            await this.$nextTick(); // Wait for dom to update and Medium Editor to be destroyed (element classes removed etc.)

            vm.updatePopupelementsFromInline();

            vm.popupelements[vm.popupelementSettingsActiveId].current.find(popupelementCurrentSetting => popupelementCurrentSetting.reference == vm.popupelementSettingsActiveRef).content = data.src;

            var popupelementHtml = $('<div></div>').append(vm.popupelements[vm.popupelementSettingsActiveId].html); 

            popupelementHtml.find('[data-reference="' + vm.popupelementSettingsActiveRef + '"]').attr('src',data.src);
            vm.popupelements[vm.popupelementSettingsActiveId].html = popupelementHtml.html()

            await this.$nextTick(); // Wait for dom to update

            vm.initMediumEditor();

            this.$bvModal.hide('modal-medialib-inline-image'); // Hide Modal


          },
          onNewPopImage: function(data){
            this.embedSettings.popimg = data.src;
            this.$bvModal.hide('modal-pop-image-cropper');
          },
          goToSettings: function(){
            $('#config-tab').trigger('click');
          },
          copyPopupCode: function(result){

                if(result){
                    
                    new Noty({
                      text: 'Copied to Clipboard',
                      type: 'success',
                      theme: 'bootstrap-v4',
                      layout: 'topCenter',
                      timeout: 1000
                    }).show();
                }
            

          },
          showAdvanced: function(){
            this.showAdvancedSettings = true;
          },
          activeTab: function(tab){
              this.tabActive = tab;
          },
          insertTag: function(event){

            let origString = this.sms_message;
            

            let startString = origString.slice(0, this.sms_input_pos_start);
            let stringToAdd = event.target.innerText;
            let endString = origString.slice(this.sms_input_pos_end);

            this.sms_message = startString+stringToAdd+endString;
            
          },
          setSmsInputPos: function(event){
            this.sms_input_pos_start = event.target.selectionStart;
            this.sms_input_pos_end = event.target.selectionEnd;
          },
          previewPopStyle: function(style){
            var vm = this;
            vm.popStylePreview = style;
          },
          selectPopStyle: function(style){
            var vm = this;
            vm.embedSettings.popstyle = style;
            vm.$refs['modal-pop-style-select'].hide();

            if(style == 1){
              //vm.$refs['modal-pop-image-cropper'].show();
            }

          },
          embedSettingsChanged: function(){
              Noty.closeAll();
               new Noty({
                text: 'Popup Code Updated - please update website code to implement changes.',
                type: 'success',
                theme: 'bootstrap-v4',
                layout: 'topCenter',
                timeout: 5000
              }).show();
          }
        },
        watch : {

          popupelements: function(){

            

            // Display Warning if mobile field is missing
            var hasMobileField = false;
              if(this.popupelements.length > 0){
              this.popupelements.forEach(element => {
                element.current.forEach(setting => {
                  if(setting.type == 'input-telephone'){
                    hasMobileField = true;
                  }
                });
              });

              if(!hasMobileField){
                  new Noty({
                          text: 'Mobile field missing. Please ensure you have included a mobile field if you wish to send your leads a SizzleDeck.',
                          type: 'warning',
                          theme: 'bootstrap-v4',
                          layout: 'topCenter',
                          timeout: false,
                          killer: true,
                      }).show();
              }else{
                Noty.closeAll();
              }
            }
          },
   
          showProfile: function(){
            
            const url = `/deck/store`;
            var vm = this;
            axios.post(url,{id:vm.popupId,show_profile:vm.showProfile}).then(response => {
              
            }).catch(() => console.warn('Oh. Something went wrong'));
              
          },
          popupelementSettingsActive: function(){
            if(this.popupelementSettingsActive){this.editingImage = false;}
          },
          deckBodyFont: function(){
            $("head").append(this.deckBodyFont.embed);
            $("head").append('<style id="dynamicStyleBodyFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleBodyFont");
            newStyleElement.html('#popupBuildArea,.note-editable{font-family:'+this.deckBodyFont["font-family"]+';}');
          },
          deckHeadingFont: function(){
            $("head").append(this.deckHeadingFont.embed);
            $("head").append('<style id="dynamicStyleHeadingFont" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleHeadingFont");
            newStyleElement.html('#popupBuildArea h1,#popupBuildArea h2,#popupBuildArea h3,#popupBuildArea h4,#popupBuildArea h5,#popupBuildArea h6,#popupBuildArea .h1,#popupBuildArea .h2,#popupBuildArea .h3,#popupBuildArea .h4,#popupBuildArea .h5,#popupBuildArea .h6,.note-editable h1,.note-editable h2,.note-editable h3,.note-editable h4,.note-editable h5,.note-editable h6,.note-editable .h1,.note-editable .h2,.note-editable .h3,.note-editable .h4,.note-editable .h5,.note-editable .h6{font-family:'+this.deckHeadingFont["font-family"]+';}');
          },
          deckAccentColor: function(){
            $("head").append('<style id="dynamicStyleAccentColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleAccentColor");
            newStyleElement.html('#popupBuildArea .accent{color:'+this.deckAccentColor+';}#popupBuildArea .avatar{ border-color:'+this.deckAccentColor+';}#popupBuildArea .border-accent{ border-top-color:'+this.deckAccentColor+';border-left-color:'+this.deckAccentColor+';border-bottom-color:'+this.deckAccentColor+';border-right-color:'+this.deckAccentColor+';}#popupBuildArea .background-accent,#popupBuildArea .sd-popupelement.background-accent{background-color:'+this.deckAccentColor+';}#popupBuildArea a:not(.social-icon,.ground){color:'+this.deckAccentColor+';}#popupBuildArea .sd-popupelement ul li::before{color:'+this.deckAccentColor+';}#popupBuildArea .sd-popupelement ol li::before{color:'+this.deckAccentColor+';}');
          },
          deckSecondaryColor: function(){
            $("head").append('<style id="dynamicStyleSecondaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleSecondaryColor");
            newStyleElement.html('#popupBuildArea .secondary{color:'+this.deckSecondaryColor+';}#popupBuildArea .border-secondary{ border-top-color:'+this.deckSecondaryColor+';border-left-color:'+this.deckSecondaryColor+';border-bottom-color:'+this.deckSecondaryColor+';border-right-color:'+this.deckSecondaryColor+';}#popupBuildArea .background-secondary,#popupBuildArea .sd-popupelement.background-secondary{background-color:'+this.deckSecondaryColor+';}');
          },
          deckTertiaryColor: function(){
            $("head").append('<style id="dynamicStyleTertiaryColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleTertiaryColor");
            newStyleElement.html('#popupBuildArea .tertiary{color:'+this.deckTertiaryColor+';}#popupBuildArea .border-tertiary{ border-top-color:'+this.deckTertiaryColor+';border-left-color:'+this.deckTertiaryColor+';border-bottom-color:'+this.deckTertiaryColor+';border-right-color:'+this.deckTertiaryColor+';}#popupBuildArea .background-tertiary,#popupBuildArea .sd-popupelement.background-tertiary{background-color:'+this.deckTertiaryColor+';}');
          },
          deckContrastColor: function(){
            $("head").append('<style id="dynamicStyleContrastColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleContrastColor");
            newStyleElement.html('#popupBuildArea, #popupBuildArea .sd-popupelement, #popupBuildArea .sd-popupelement.skin-light, #popupBuildArea .contrast{color:'+this.deckContrastColor+';} #popupBuildArea .background-contrast{background-color:'+this.deckContrastColor+';}');
          },
          deckGroundColor: function(){
            $("head").append('<style id="dynamicStyleGroundColor" type="text/css"></style>');
            var newStyleElement = $("head #dynamicStyleGroundColor");
            newStyleElement.html('#popupBuildArea .sd-popupelement.skin-dark, #popupBuildArea .ground{color:'+this.deckGroundColor+';}#popupBuildArea .background-ground,#popupBuildArea .sd-popupelement{background-color:'+this.deckGroundColor+';}');
          },
          dynamicOgImage: function(){
            var vm = this;
            if(vm.dynamicOgImage){
              const url = `/deck/store`;
              axios.post(url,{id:this.popupId,og_image_static:null}).then(response => {
                 this.staticOgImage = null;
              }).catch(() => console.warn('Oh. Something went wrong'));

            }
          },
          embedSettings: function(){
            if(this.embedSettings.popstyle == 0){this.embedSettings.popimg = null;}            
          }

        },
        computed: {
          embedCode: function(){
            if(this.isMounted){              

              return '\<script\>(function(w, d) { w.id = "'+this.popupId+'"; w.url = "'+this.deckDefaults.baseurl+'"; w.delay='+this.embedSettings.delay+'; w.cookieClosed='+this.embedSettings.cookieClosed+'; w.cookieCompleted='+this.embedSettings.cookieCompleted+'; w.autoclose='+this.embedSettings.autoclose+'; w.position="'+this.embedSettings.position+'"; w.popstyle='+this.embedSettings.popstyle+'; w.popimg="'+((this.embedSettings.popstyle==1)?this.embedSettings.popimg:'')+'"; var h = d.head || d.getElementsByTagName("head")[0]; var s = d.createElement("script"); s.setAttribute("type", "text/javascript"); s.async=true; s.setAttribute("src", "'+this.deckDefaults.baseurl+'/js/embed.js"); h.appendChild(s); })(window, document);\<\/script\>';

            }else{
              return '';
            }
          }
        }
    }
</script>


